import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Form, Button, Alert, Modal, Container } from "react-bootstrap";
import "./maindashboard.css";
import Header from "../../components/NewHeader/Header";
import Logout from "../../components/logout/Logout";
import HomeIcon from "@material-ui/icons/Home";
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined';
import PermIdentityOutlinedIcon from '@material-ui/icons/PermIdentityOutlined';
import ReportIcon from "@material-ui/icons/Report";
import AssignmentIcon from "@material-ui/icons/Assignment";
import LockIcon from "@material-ui/icons/Lock";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import defaultProfile from "../../assets/images/default-profile-icon.jpg";
import axios from "axios";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import genie_img from "../../assets/images/Genie_Sitting.svg";
import Wishes_icon from "../../assets/images/Wishes_icon.jpg";
import key_gold from "../../assets/images/key gold.png";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import Close from "../../assets/images/close.png";
import ScreenShareIcon from "@material-ui/icons/ScreenShare";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { ContentState, EditorState, SelectionState } from "draft-js";
import SmsIcon from '@mui/icons-material/Sms';
import { Editor } from "react-draft-wysiwyg";
import {
  convertToRaw
} from "draft-js";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js/pure';
import { Elements } from "@stripe/react-stripe-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

import {
  FormControlLabel,
  styled,
  Switch,
  TextField,
} from "@material-ui/core";
import { cleanup } from "@testing-library/react";
import Checkinbutton from "../../assets/images/checkinbuttonMain.png";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import OtpInput from "react-otp-input";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";
import Draggable from "react-draggable";
import ic_users from "../../assets/images/ic_users.png";
import Password_icon from "../../assets/images/password_incon.png";
import profile_icon from "../../assets/images/profile_icon.png";
import Serive_icon from "../../assets/images/service_planning.png";
import memory_icon from "../../assets/images/memory_icon.jpg";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import SentInvitaionModel from "../sentInvitaionModel";
import SharedAccessApprovalModal from "../../components/SharedAccessApprovalModal";
import { wish } from "../../utils/wishes.utils";
import Cookie from "../../utils/cookie";
import { priceplans } from "../MyServicePlan/MyServicePlanSelection";
import { pdfLists } from "../../utils/pdfLists";
import HandleConfirmation from "../handleConfirmation";
import { pdfLists2 } from "../../utils/pdfLists2";
import CloseIcon from "@mui/icons-material/Close";
import why_this_organize from "../../PdfPages2/why_this_organize.pdf";
import my_story from "../../PdfPages2/my_story.pdf";
import AddAlertIcon from '@mui/icons-material/AddAlert';
import { reset } from "react-tabs/lib/helpers/uuid";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DateRangeIcon } from "@mui/x-date-pickers";


const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightBold,
    },
  })
);
loadStripe.setLoadParameters({ advancedFraudSignals: false });

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(22px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#0069d9",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 16,
    height: 16,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const basicFeatures = [
  "Allows up to 3 Emergency Contacts",
  "The Check In Frequency is every other day",
  "Text you a Reminder on day of Check In",
];

const customFeatures = [
  "Allows up to 3 Emergency Contacts",
  "Allows you to choose your desired check-in frequency",
  "Allows you to schedule a Date that is not already scheduled at any time",
  "Allows you to change and regenerate your Check In frequency at any time",
  "Allows you to enter a custom Message that will be sent to your Emergency Contacts if you don't check in when scheduled",
  "Allows you to enter a Social Media link in the Message",
  "Text you a Reminder on day of Check In",
];

const descriptions = {
  basic: {
    title: "Basic Check In Description",
    body: [
      "Allows up to 3 Emergency Contacts",
      "The Check In Frequency is every other day",
      "Text you a Reminder on day of Check In",
    ],
  },
  custom: {
    title: "Custom Check In Description",
    body: [
      "Allows up to 3 Emergency Contacts",
      "Allows you to choose your desired check-in frequency",
      "Allows you to schedule a Date that is not already scheduled at any time",
      "Allows you to change and regenerate your Check In frequency at any time",
      "Allows you to enter a custom Message that will be sent to your Emergency Contacts if you don't check in when scheduled",
      "Allows you to enter a Social Media link in the Message",
      "Text you a Reminder on day of Check In",
    ],
  },
};


const Maindashboard = () => {
  const classes = useStyles();
  let history = useHistory();
  let stripePromise;
  const editorRef = useRef(null);
  const [stripePromises, setStripePromises] = useState(null);
  const [servicePlanRequired, setServicePlanRequired] = useState(null);
  const nUserID = localStorage.getItem("userid");
  const token = localStorage.getItem("token");
  const [BannderAd, setBannerAd] = useState("");
  const [modalOpen, setOpen] = React.useState(false);
  const [s3filename, sets3filename] = useState(null);
  const [email1, setEmail1] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [ReportMessage, setReportMessage] = React.useState();
  const [number, setnumber] = useState("");
  const [quoteoftheday, setquoteoftheday] = useState("");
  const [ReportIssues, setReportIssues] = useState(false);
  const [accessRequest, setAccessRequest] = useState(false);

  const [showDescModal, setShowDescModal] = useState(false);
  const [descType, setDescType] = useState(null); // "basic" | "custom"

  const [LegendData, setLegendData] = React.useState("");
  const [LegendDataHome, setLegendDataHome] = React.useState("");
  const [otp, setOTP] = React.useState("");
  const [showLegend, setShowLegend] = useState(false);
  const [otpisValid, setotpisValid] = React.useState(false);
  const [otpModalOpen, setotpModalOpen] = useState(false);
  const [isSending, setIsSending] = useState(false);

  // profile data
  const [ShowAccordian, setShowAccordian] = React.useState(false);
  const [nShowads, setnShowads] = React.useState();
  const [currentUser, setCurrentUser] = React.useState();
  const [letsgetstarted, setletsgetstarted] = useState("");
  const [checkInTime, setCheckInTime] = useState("");
  const [AccessCode, setAccessCode] = useState("");
  const [confirmAccessCode, setConfirmAccess] = useState("");
  const [isNewUser, setIsNewUser] = useState("");
  const [openNewUserModel, setOpenNewUserModel] = useState(false);
  const [isServicePlanSelected, setisServicePlanSelected] = useState(false);
  const [openRequiredModel, setopenRequiredModel] = useState(false);
  const [openActiveModel, setopenActiveModel] = useState(false);
  const [showInvalidCheckModal, setShowInvalidCheckModal] = useState(false);
  const [showAlreadyCheckedInModal, setShowAlreadyCheckedInModal] = useState(false);
  const [showCheckInDatesModal, setShowCheckInDatesModal] = useState(false);
  const [showOldCheckInDatesModal, setShowOldCheckInDatesModal] = useState(false);
  const [checkInDates, setCheckInDates] = useState([]);
  const [oldCheckInDates, setOldCheckInDates] = useState([]);

  const [sharedReleaseCount, setSharedReleaseCount] = useState(null);
  const [showAcceptConfirmationModal, setShowAcceptConfirmationModal] = useState(false);
  const [shareWithGuest, setShareWithGuest] = useState(false);
  const [profileImage, setProfileImage] = useState('');

  const [isOpenSharedModal, setOpenSharedModal] = useState(false);
  const [confirmAccessData, setConfirmAccessData] = useState('');
  const [isTwoFactorChecked, setIsTwoFactorChecked] = useState("");
  const [serviceplandata, setserviceplandata] = useState(false);
  const [servicePlan, setServicePlan] = useState(null);
  const [isLoadingPlan, setIsLoadingPlan] = useState(false);
  const [accessType, setAccessType] = useState(null);
  const [openPrintPagesModel, setOpenPrintPagesModel] = useState(false);
  const [selectedValues, setSelectedValues] = useState("")
  const [getDefaultAlign, setgetDefaultAlign] = useState(0);
  const [showViewMemoryBtn, setShowViewMemoryBtn] = useState(true);
  const [bookVersion, setBookVersion] = useState("version_2");

  const halfLength = Math.ceil(pdfLists.length / 2);
  const halfLength2 = Math.ceil(pdfLists2.length / 2);
  const firstHalf = bookVersion === "version_2" ? pdfLists2.slice(0, halfLength2) : pdfLists.slice(0, halfLength);
  const secondHalf = bookVersion === "version_2" ? pdfLists2.slice(halfLength2) : pdfLists.slice(halfLength);
  const [isOpenPersonalAffairsModal, setPersonalAffairsModal] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [openAsinNumberModal, setOpenAsinNumberModal] = useState(false)
  const [wrongAsinNumber, setWrongAsinNumber] = useState(false)
  const [asinValue, setAsinValue] = useState("");
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [errors, setErrors] = useState({ email: '', code: '' });
  const storageKey = 'servicePlanAttempts';
  const [attempts, setAttempts] = useState(parseInt(localStorage.getItem(storageKey)) || 0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(attempts >= 3);
  const [modalMessage, setModalMessage] = useState('');
  const [openConformModel, setOpenConformModel] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [formData, setFormData] = useState({
    id: 0,
    date: "",
    message: "",
  });
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [errormessage, setErrormessage] = useState("");
  const [successmessage, setSuccessmessage] = useState("");

  const [option1Value, setOption1Value] = useState(null);
  const [yearlyCheckInRate, setYearlyCheckInRate] = useState(null);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [dropdownValue, setDropdownValue] = useState("");
  const [cardType, setCardType] = useState('all')
  const [prgressIn, setPrgressIn] = useState(false)
  const [paymentEmail, setPaymentEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [name, setName] = useState('')
  const [error, setError] = useState(null);
  const [cardComplete, setCardComplete] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [success, setSuccess] = useState("");
  const [isChekIn, setIsChekIn] = useState(false);
  const [showNextCheckInModal, setShowNextCheckInModal] = useState(false);
  const MAX_CHARS = 2000;
  const selectedPlan = Array.isArray(dropdownOptions)
    ? dropdownOptions.find(
      (opt) => String(opt.id) === String(dropdownValue)
    )
    : undefined;
  const handleShowPlanModal = (value) => {
    setSuccess("");
    setShowPlanModal(value);
  };

  const [showCalendar, setShowCalendar] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [hoveredDate, setHoveredDate] = useState(null);
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedDate(null);
  };

  useEffect(() => {
    if (!showAddEditModal) return;

    if (formData.message) {
      const { contentBlocks, entityMap } = htmlToDraft(formData.message);

      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );

      setEditorState(EditorState.createWithContent(contentState));
    } else {
      setEditorState(EditorState.createEmpty());
    }
  }, [showAddEditModal]); // 👈 REMOVE formData.message

  useEffect(() => {
    getServicePlanIDs();
  }, []);

  const getCharCount = (state) =>
    state.getCurrentContent().getPlainText("").length;

  const handleBeforeInput = () => {
    const currentLength = getCharCount(editorState);
    if (currentLength >= MAX_CHARS) {
      return "handled";
    }
    return "not-handled";
  };

  const getServicePlanIDs = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };

      const option1Res = await axios.get(
        process.env.REACT_APP_SERVER + "user/getServicePlanIDs",
        { params: { optionWhichOne: 1 }, headers }
      );

      setOption1Value(option1Res.data[0]?.id || 45);
      setYearlyCheckInRate(option1Res.data[0]?.yearlyCheckInRate)

      const option2Res = await axios.get(
        process.env.REACT_APP_SERVER + "user/getServicePlanIDs",
        { params: { optionWhichOne: 2 }, headers }
      );

      setDropdownOptions(option2Res.data); // <-- directly the array
    } catch (err) {
      console.log("Service plan error:", err);
    }
  };

  const handleCancel = () => {
    if (servicePlan?.id) {
      // setSelectedOption(2);
      setDropdownValue(servicePlan?.id);
      setSelectedOption(null);
      handleShowPlanModal(false);
    }
    else {
      setDropdownValue("");
      setOption1Value(null);
      setSelectedOption(null);
      handleShowPlanModal(false);
    }
  };

  const handleSave = () => {
    let payload = {};
    if (selectedOption === 1) {
      payload = {
        optionWhichOne: 1,
        servicePlanID: option1Value === null ? 45 : option1Value || 45, // id
      };
      handleCheckInFrequency(option1Value);
    }

    if (selectedOption === 2) {
      payload = {
        optionWhichOne: 2,
        servicePlanID: dropdownValue, // selected id
      };
      handleCheckInFrequency(dropdownValue);
    }

  };


  useEffect(() => {
    localStorage.setItem(storageKey, attempts);
  }, [attempts]);

  useEffect(() => {
    const savedEmail = localStorage.getItem('email');
    if (savedEmail) {
      setEmail(savedEmail);
    } else {
      setEmail('')
    }
  }, []);

  function handleChange(e) {
    setError(e.error);
    setCardComplete(e.complete);
    if (e.elementType === 'cardNumber') {
      setCardType(e.brand == 'unknown' ? 'all' : e.brand)
    }
  }

  const ErrorMessage = ({ children }) => (
    <div className="ErrorMessage" role="alert">
      <svg width="16" height="16" viewBox="0 0 17 17">
        <path
          fill="red"
          d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
        />
        <path
          fill="white"
          d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
        />
      </svg>
      {children}
    </div>
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!email) newErrors.email = 'Email is required';
    if (!code) newErrors.code = 'Code is required';
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    try {
      const res = await axios.post(process.env.REACT_APP_SERVER + 'activateServicePlan', {
        sEmail: email,
        sCode: code
      });
      console.log(res)
      if (res.status === 200) {
        const responseData = res.data[0];
        if (responseData.retValue === 1) {
          setModalMessage('Service Plan as be Activated!');
          setAttempts(0);
          setIsButtonDisabled(false);
        } else if (responseData.retValue === 0) {
          setModalMessage('Active Plan Code be Invalid!');
          setAttempts(attempts + 1);
          if (attempts >= 2) {
            setIsButtonDisabled(true);
          }
        } else {
          console.error('Unexpected response:', responseData);
        }
      } else {
        console.error('Error activating service plan:', res.status);
        setModalMessage('Failed to activate service plan. Please try again.');
      }
    } catch (error) {
      console.error('Error activating service plan:', error);
      alert('Failed to activate service plan. Please try again.');
    }
    setOpenConformModel(true);
    handleActivePlan();
  };

  const handlePaymentSubmit = e => {
    e.preventDefault();
    console.log("Handle Payment Submit")
  }

  const toggleApprovalModal = () => {
    setOpenSharedModal(!isOpenSharedModal);
  }
  const handleDownload = () => {
    if (bookVersion === "version_2") {
      wish.downloadPdfByType2(selectedValues)
    } else {
      wish.downloadPdfByType(selectedValues)
    }
  };

  const checkAsinNumber = (event) => {
    event.preventDefault();
    const correctASIN = "B0D7V33HFM"
    if (correctASIN === asinValue) {
      bookVersion === "version_2" ? wish.downloadPdfByType2(selectedValues) : wish.downloadPdfByType(selectedValues)
      setOpenAsinNumberModal(false);
      handlePrintPages();
    } else {
      setOpenAsinNumberModal(false);
      setWrongAsinNumber(true);
    }
    setAsinValue('')
    setSelectedValues("");
  }

  const handlecloseASINModal = () => {
    setOpenAsinNumberModal(false);
  }

  const handleCloseWrongAsinNummberModal = () => {
    setWrongAsinNumber(false);
    handlePrintPages();
  }

  const handleShareWithGuestModel = () => {
    setShareWithGuest(!shareWithGuest)
  }
  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedValues(value);
    } else {
      setSelectedValues("");
    }
  }
  const handlePrintPages = () => {
    setOpenPrintPagesModel(!openPrintPagesModel);
  }

  const handleServicePlan = () => {
    setopenRequiredModel(!openRequiredModel);
    setIsChekIn(false);
  };

  const handleActivePlan = () => {
    setErrors({ email: '', code: '' });
    setCode('');
    setopenActiveModel(!openActiveModel);
  };

  const handleShowActiveModel = () => {
    if (!isButtonDisabled) {
      setopenActiveModel(true);
    }
  }
  const handleShowRequiredModel = () => setopenRequiredModel(false);

  const redirectServicePlan = () => {
    handleShowRequiredModel()
    handleShowActiveModel()
    // history.push("/chooseServicePlan");
  };

  const handleRoutes = (link) => {
    if (isServicePlanSelected) {
      handleServicePlan(true);
    } else {
      history.push(link);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("token") == null) {
      history.push("/");
    }
    LastcheckInTime();
    getCurrentIp();
    getServicePlan()
  }, []);

  const LastcheckInTime = () => {
    const data = { nUserID };
    axios
      .post(process.env.REACT_APP_SERVER + `user/getusercheckins`, data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => {
        setCheckInTime(res.data[0].checkintime);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const defaultFocus = document.querySelector(".otpInputBox input");

  useEffect(() => {
    AutoFocusInput();
    setTimeout(() => {
      AutoFocusInput();
    }, 500);
  }, [otpModalOpen, defaultFocus]);

  const AutoFocusInput = () => {
    if (defaultFocus !== null) {
      defaultFocus.focus();
    }
  };

  const handleReportIssuse = () => {
    setReportIssues(!ReportIssues);
  };
  const handlesubmitReport = (e) => {
    e.preventDefault();
    const data = {
      sfullname: fname + " " + lname,
      semailaddress: email1,
      smessage: ReportMessage,
    };
    axios
      .post(process.env.REACT_APP_SERVER + "usergetandsendemail", data)
      .then((res) => {
        handleReportIssuse();
        handlecloseMassageModel();
        setFname("");
        setLname("");
        setReportMessage("");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleAlignment = (newAlignment) => {
    setgetDefaultAlign(parseInt(newAlignment));
    localStorage.setItem("dashboardLayout", newAlignment);
    if (newAlignment === 0 || newAlignment === 1 || newAlignment === 2) {
      saveAlignment();
    } else {
      if (parseInt(localStorage.getItem("isAuthenticatedOTP")) === 0) {
        setSendOTP(true);
      }
    }
  };

  const saveAlignment = () => {
    const data = {
      nUserID: localStorage.getItem("userid"),
      nFlag: localStorage.getItem("dashboardLayout"),
    };
    var token = localStorage.getItem("token");

    axios.post(
      process.env.REACT_APP_SERVER + "user/usercheckinbuttonflagsave",
      data,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  };

  const [nextcheckindate, setNextcheckindate] = useState("");
  const setLocalStorage = (key, val) => {
    localStorage.setItem(key, val);
  };

  function profileDetailGet() {
    setgetDefaultAlign("");
    var token = localStorage.getItem("token");
    return axios
      .get(process.env.REACT_APP_SERVER + "profile/detail", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setCurrentUser(res.data[0]);
        const element = res.data[0];
        const userName = element.fname + ' ' + element.lname;
        localStorage.setItem("name", userName);
        setFname(element.fname);
        setLname(element.lname);
        setEmail1(element.email1);
        sets3filename(element.s3filename);
        setnShowads(element.showads);
        setnumber(element.phone1);
        setquoteoftheday(element.quoteoftheday.replaceAll("\n", ""));
        setletsgetstarted(element.letsgetstarted);
        setstart(element.letsgetstarted);
        setIsTwoFactorChecked(element.twofactorauth);
        setNextcheckindate(element.nextcheckindate);
        setIsNewUser(element.newuser);
        setisServicePlanSelected(element.serviceplanrequired === 1);
        setShowViewMemoryBtn(element.viewMemoriesButton === 1)
        setServicePlanRequired(element.serviceplanrequired);

        if (Boolean(element.twofactorauth) && Cookie.get("isFirstTime") === "1") {
          setSendOTP(true);
        }
        getSharedReleaseSummary(element.twofactorauth);

        const userId = localStorage.getItem('userid');
        if (element.s3filename) {
          axios.get(process.env.REACT_APP_SERVER + `gets3file?filename=${element.s3filename}&nUserID=${userId}`,
            { headers: { Authorization: `Bearer ${token}` } })
            .then((res) => {
              setProfileImage(res.data.url);
            }).catch((err) => {
              return 'error';
            })
        }

        const newUser = element.newuser;
        if (newUser === 1) {
          setLocalStorage("isAuthenticatedOTP", "1");
          if (localStorage.getItem("dashboardLayout") === "0") {
            setgetDefaultAlign(0);
          } else if (localStorage.getItem("dashboardLayout") === "1") {
            setgetDefaultAlign(0);
          } else {
            setgetDefaultAlign(0);
            setLocalStorage("dashboardLayout", 0);
          }
        } else if (newUser === 0 && element.twofactorauth === 1) {
          // setLocalStorage("isAuthenticatedOTP", "0");
          if (localStorage.getItem("dashboardLayout") === "0") {
            setgetDefaultAlign(0);
          } else if (localStorage.getItem("dashboardLayout") === "1") {
            setgetDefaultAlign(1);
          } else {
            setgetDefaultAlign(0);
            setLocalStorage("dashboardLayout", 0);
          }
        } else if (newUser === 0 && element.twofactorauth === 0) {
          setLocalStorage("isAuthenticatedOTP", "1");
          if (localStorage.getItem("dashboardLayout") === "0") {
            setgetDefaultAlign(0);
          } else if (localStorage.getItem("dashboardLayout") === "1") {
            setgetDefaultAlign(1);
          } else {
            setgetDefaultAlign(0);
            setLocalStorage("dashboardLayout", 0);
          }
        } else if (newUser === 0) {
          if (localStorage.getItem("isBtnClicked") === "false") {
            setLocalStorage("isAuthenticatedOTP", "1");
            setLocalStorage("dashboardLayout", 0);
            setgetDefaultAlign(0);
          }
        } else if (newUser === 1 && element.twofactorauth === 1) {
          setLocalStorage("isAuthenticatedOTP", "0");
          setLocalStorage("dashboardLayout", 0);
          setgetDefaultAlign(0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    profileDetailGet();
    handleletstart();
  }, []);

  function closeModal() {
    setOpen(false);
  }

  function OpenSidebar() {
    setOpen(true);
  }

  const handleCloseLegend = () => {
    setShowLegend(false);
  };

  const getLegendDataHome = (whichScreen = "") => {
    setHomeModel(true);
    axios
      .get(process.env.REACT_APP_SERVER + `readme?nWhichScreen=${whichScreen}`)
      .then((res) => {
        setLegendDataHome(res.data[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [planNotSelected, setSelectPlan] = useState(false);

  const handleClosePlan = () => {
    setSelectPlan(false);
  };

  const [sIPAddress, setCurrentIp] = useState("");
  const [shows, setshows] = useState(false);


  const handleServicePlanOpen = () => {
    setopenRequiredModel(true);
  };

  const handleOpenModel = () => {
    setshows(true);
  };
  const handleCloseModel = () => {
    setshows(false);
  };

  const getCurrentIp = () => {
    axios
      .get("https://geolocation-db.com/json/")
      .then((res) => {
        setCurrentIp(res.data.IPv4);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const HandleCheckIn = () => {
    if (
      currentUser?.nextcheckindate &&
      !moment(currentUser.nextcheckindate).isSame(moment(), "day")
    ) {
      setShowNextCheckInModal(true);
      return;
    }
    // if (isNewUser || isServicePlanSelected) {
    //   handleShowPlanModal(true)
    //   // setopenRequiredModel(true);
    //   setIsChekIn(true);
    // } else 
    if (
      moment(checkInTime).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")
    ) {
      setShowAlreadyCheckedInModal(true);
    } else if (
      moment(nextcheckindate).isSameOrBefore(moment().format("YYYY-MM-DD"))
    ) {
      const nSystemUserID = 0;
      const sMethod = "Android";
      const sNotes = "Notes";
      const data = { nUserID, nSystemUserID, sMethod, sNotes, sIPAddress };
      axios.get(process.env.REACT_APP_SERVER + "profile/detail", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
        .then((resp) => {

          if (resp.data[0].newuser === 1) {
            handleOpenModel();
          } else if (resp.data[0].serviceplanrequired === 1) {
            handleServicePlanOpen();
          } else {
            axios.post(process.env.REACT_APP_SERVER + `user/setusercheckins`, data, {
              headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            })
              .then((res) => { })
              .catch((err) => {
                console.log(err);
              });
            history.push("/CheckInResponse");
          }
        });
    } else {
      setShowInvalidCheckModal(true);
    }
  };

  const expanded = "panel1";

  const [HomeGenieModel, setHomeModel] = useState(false);

  const handleClose = () => {
    setHomeModel(false);
    setLegendDataHome({ LegendDataHome: cleanup });
  };

  const styles = {
    bgColor: {
      backgroundColor: "#0069d9",
      color: "white",
      padding: "7px 10px",
    },
    textDecoration: {
      textDecoration: "underline",
    },
  };

  const getSharedReleaseSummary = (twoFactorEnabled = false) => {
    axios.get(process.env.REACT_APP_SERVER + `inventory/getSharedReleaseSummary?nUserID=${nUserID}&nContactID=${0}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((res) => {
        setSharedReleaseCount(res.data[0])
        if (res.data[0]["hasAccessRequestFlag"] === 1) {
          if (isNewUser == 0) {
            Cookie.save("isPendingApproval", "1");
          }
          if (!localStorage.getItem("isApprovedModal") && !Boolean(twoFactorEnabled)) {
            localStorage.setItem("isApprovedModal", "1");
            toggleApprovalModal();
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleOtpModelclose = () => {
    setotpModalOpen(false);
    setSendTwoFactorOTP(false);
  };

  const handleChangeotp = (otp) => {
    setOTP(otp);
  };

  const allowedEmails = [
    "randall_arnwine@hotmail.com",
    "randall_arnwine99@hotmail.com",
  ];

  const canShowTestText =
    allowedEmails.includes(currentUser?.email1) ||
    allowedEmails.includes(currentUser?.email2);

  const [sendOTP, setSendOTP] = useState(false);
  const [sendTwoFactorOTP, setSendTwoFactorOTP] = useState(false);
  const [selectedType, setSelectedType] = useState("email");

  const handleCloseOTPVerificationModal = () => {
    setotpisValid(false);
    setSendOTP(false);
    setOTP("");
    localStorage.setItem("dashboardLayout", 0);
  };

  const [invitaionModel, setInvitaionModel] = useState(false);

  const handleInvitaionModel = () => {
    setInvitaionModel(!invitaionModel);
  };

  const handleSubmitOTP = () => {
    setIsSending(true);
    axios
      .post(process.env.REACT_APP_SERVER + "usersendsms", {
        sphonenumber: selectedType === "phone" ? number : "",
        smessage: "Your KeysToMyWishes verification code is",
        smessageSMS: "Your KeysToMyWishes verification code is",
        ssubject: "keys to my wishes Verification Code",
        swhoto: null,
        semailaddress: selectedType === "email" ? email1 : "",
        nUserID: localStorage.getItem("userid"),
        nContactID: localStorage.getItem("userid"),
        bEmailSent: selectedType === "email",
        bTextSent: selectedType === "phone",
        otpParam: 1
      })
      .then(() => {
        setSelectedType("email");
        setIsSending(false);
        setotpModalOpen(true);
        if (sendTwoFactorOTP) {
          handleAuthApi(0);
        }
        handleCloseOTPVerificationModal();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [validOTP, setValid] = useState();
  const [suspendChekdIn, setSuspendChekdIn] = useState(false);
  const [checkInOnOff, setCheckInOnOff] = useState(
    currentUser?.checkinOnOff === 1 ? 1 : 0
  );

  const hadleSuspendChekedIn = () => {
    setSuspendChekdIn(true)
  }

  const handleSuspendCheckIn = () => {
    const data = {
      nUserID: localStorage.getItem("userid"),
      onOff: checkInOnOff,
    }
    axios
      .post(process.env.REACT_APP_SERVER + `user/checkInEnable`, data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then(() => {
        setSuspendChekdIn(false);
        profileDetailGet();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleValidatetwofactor = () => {
    if (otp.length < 6) {
      setotpisValid(true);
      setValid("Please enter a OTP.");
    } else {
      axios
        .post(process.env.REACT_APP_SERVER + "usercontactsharedwithaccessverify", {
          nUserID: localStorage.getItem("userid"),
          nContactID: localStorage.getItem("userid"),
          otpcode: otp,
        }).then((res) => {
          profileDetailGet();
          if (res.data[0]["retValue"] === 0) {
            setValid(res.data[0]["retMsg"]);
            setotpisValid(true);
          }
          if (res.data[0]["retValue"] === 1) {
            setSendOTP(false);
            setotpModalOpen(false);
            Cookie.save("isFirstTime", "0");
            localStorage.setItem("isAuthenticatedOTP", "1");
            setgetDefaultAlign(0);
          } else {
            setotpModalOpen(true);
            setotpisValid(true);
          }
        })
        .catch((err) => {
          setotpisValid(true);
        });
    }
  };

  const handleCheckAccount = () => {
    localStorage.setItem("serviceplanrequired", 0);
  };
  const [massagemodel, setMessageModel] = useState(false);

  const handlecloseMassageModel = () => {
    setMessageModel(!massagemodel);
  };

  const seriveModelclose = () => {
    setserviceplandata(false);
  };
  const [getstartData, setgetstartData] = React.useState("");

  const [start, setstart] = useState(true);

  const closeStart = () => {
    setstart(false);
    handleApilets(0);
    setletsgetstarted(0);
    setstart(0);
  };

  const handleletstart = () => {
    axios
      .get(process.env.REACT_APP_SERVER + `readme?nWhichScreen=30`)
      .then((res) => {
        setgetstartData(res.data[0]);
        setstart(!start);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSettingFor = (e) => {
    Cookie.save("isFirstTime", "0");
    if (isNewUser === 1) {
      setOpenNewUserModel(true);
    } else {
      if (e.target.checked) {
        setIsTwoFactorChecked(1);
        handleAuthApi(1);
      } else {
        setSendOTP(true);
        setSendTwoFactorOTP(true);
      }
    }
  };

  const handleNewUser = () => {
    setOpenNewUserModel(!openNewUserModel);
  };

  const handleNextCheckInModal = () => {
    setShowNextCheckInModal(!showNextCheckInModal);
  };

  const handleletgetstart = (e) => {
    if (e.target.checked) {
      handleApilets(1);
      setletsgetstarted(1);
      setstart(1);
    } else {
      handleApilets(0);
      setletsgetstarted(0);
      setstart(0);
    }
  };

  const handleApilets = (nFlag) => {
    axios
      .post(
        process.env.REACT_APP_SERVER +
        `user/userletsgetstartedsave?nUserID=${nUserID}&nFlag=${nFlag}`,
        null,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleAuthApi = (nFlag) => {
    axios
      .post(
        process.env.REACT_APP_SERVER +
        `user/usertwofactorauthsave?nUserID=${nUserID}&nFlag=${nFlag}`, {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleBtnClicked = (val) => {
    localStorage.setItem("isBtnClicked", val);
  };

  const profileLink = () => {
    history.push("/my-profile");
  };

  const ServiceLink = () => {
    return (!isLoadingPlan && !servicePlan) ? (window.open('/products', '_blank')) : (window.open('/products', '_blank'));
  };

  const ChangePasswordLink = () => {
    history.push("/change-password");
  };

  const handleChangeTab = (e, newValue) => {
    handleAlignment(0);
    localStorage.setItem("isBtnClicked", Boolean(newValue));
  };

  const handleShowCheckInDatesModal = () => {
    // if (isNewUser || isServicePlanSelected) {
    // setopenRequiredModel(true);
    // if (currentUser?.nHasCheckInDates === 0) {
    //   handleShowPlanModal(true);
    // } else {
    setShowCheckInDatesModal(true);
    axios
      .get(
        process.env.REACT_APP_SERVER +
        `user/getFutureCheckInDates?nUserID=${nUserID}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        const formattedDates = res.data.map((item) => ({
          id: item.id,
          date: item.CheckInDate,
          msg: item.msg,
        }));

        setCheckInDates(formattedDates);
      });
    // }
  };

  const handleShowOldCheckInDatesModal = () => {
    if (isNewUser || isServicePlanSelected) {
      setopenRequiredModel(true);
    } else {
      setShowOldCheckInDatesModal(true);
      axios
        .get(
          process.env.REACT_APP_SERVER +
          `user/getPastCheckInDates?nUserID=${nUserID}`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then((res) => {
          const formattedDates = res.data.map((item) => ({
            id: item.id,
            date: item.CheckInDate,
            msg: item.msg,
          }));

          setOldCheckInDates(formattedDates);
        });
    }
  };

  const getReadMe = (request) => {
    return axios.get(process.env.REACT_APP_SERVER + `readme?nWhichScreen=61`)
      .then((res) => {
        const userName = `${fname} ${lname}`
        return res.data[0]["thetext"]
          .replace("&lt;username&gt;", request["swhoto"])
          .replace("&lt;contactname&gt;", request["scontactname"])
      }).catch((err) => {
        console.log(err)
      })
  }

  const submitAccessCode = () => {
    const url = accessType === 'Share' ? `inventory/requestaccess` : `inventory/requestReleaseAccess`
    const params = {
      params: {
        nUserID: nUserID,
        sRequestCode: AccessCode
      },
      headers: { Authorization: `Bearer ${token}` }
    }
    axios.post(process.env.REACT_APP_SERVER + url, {}, params)
      .then((res) => {
        if (res.status === 200) {
          setConfirmAccessData(res.data[0].ReturnValue);
          if (res.data[0].sendSMS === 1) {
            const request = res.data[0];
            getReadMe(request).then((response) => {
              axios.post(process.env.REACT_APP_SERVER + 'usersendsms', {
                ssubject: request.ssubject,
                nUserID: nUserID,
                smessage: response,
                smessageSMS: wish.removeHtml(response),
                nContactID: 0,
                sphonenumber: request["sphonenumber"],
                semailaddress: request["semail"],
                swhoto: request.swhoto,
                bEmailSent: !!request["semail"],
                bTextSent: !!request["sphonenumber"],
                otpParam: 0
              }).then(() => {
                setAccessRequest(false);
                setConfirmAccess(true);
              })
            })
          } else {
            setAccessRequest(false);
            setConfirmAccess(true);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  const logoutHandler = () => {
    let userId = localStorage.getItem('userid')
    const data = { nUserID: userId };
    var token = localStorage.getItem('token');
    axios.post(`${process.env.REACT_APP_SERVICE_PLAN_API}auth/logout`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    ).then(res => {
      localStorage.clear();
      Cookie.delete("isFirstTime");
      Cookie.delete("isPendingApproval");
      history.push("/new-login")
    }).catch(e => {
      localStorage.clear();
      history.push("/new-login")
    })
  }

  const getServicePlan = () => {
    var token = localStorage.getItem('token');
    const nUserID = localStorage.getItem('userid');
    const data = { nUserID }
    setIsLoadingPlan(true);
    axios.post(process.env.REACT_APP_SERVER + `user/getuserserviceplan`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    ).then((res) => {
      setIsLoadingPlan(false);
      if (res.data.status) {
      } else {
        if (res.data[0] == undefined || null) {
        } else {
          setServicePlan(res.data[0])
        }
      }
    }).catch((err) => {
      setIsLoadingPlan(false);
      console.log(err)
    })
  }

  const handleDelete = () => {
    var userId = localStorage.getItem("userid");

    axios
      .post(process.env.REACT_APP_SERVER + `user/checkInDeleteDate?nUserID=${userId}&nRecordID=${selectedDate?.id}`, {}, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        handleShowCheckInDatesModal()
        handleCloseDeleteModal();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleAddOrEditDate = () => {
    const userId = localStorage.getItem("userid");

    const payload = {
      nUserID: userId,
      nRecordID: formData?.id,
      dtDate: formData?.date,
      sMsg: formData?.message
    };

    axios.post(
      `${process.env.REACT_APP_SERVER}user/checkInAddDateMsg`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
      .then((res) => {

        // if duplicate error
        if (res?.data && res.data[0]?.NoDupsAllowed) {
          setErrormessage(res.data[0].NoDupsAllowed);
          setSuccessmessage("");
          profileDetailGet();
          setSelectedDate("");
          return;
        }

        // if success message
        if (res?.data && res.data[0]?.SuccessNewValue) {
          setSuccessmessage(res.data[0].SuccessNewValue);
          setErrormessage("");

          // show message for 1 second then close
          setTimeout(() => {
            handleShowCheckInDatesModal();
            setShowAddEditModal(false);
          }, 1000);
          profileDetailGet();
          setSelectedDate("")
          return;
        }

        // if response is [] => treat as success
        if (Array.isArray(res?.data) && res.data.length === 0) {
          handleShowCheckInDatesModal();
          setShowAddEditModal(false);
          profileDetailGet();
          setSelectedDate("")
          return;
        }

      })
      .catch((err) => {
        console.log(err);
        setErrormessage("Something went wrong. Please try again.");
      });
  };

  useEffect(() => {
    if (servicePlan?.id) {
      // setSelectedOption(2);
      setDropdownValue(servicePlan?.id);
    }
  }, [servicePlan]);

  const handleCheckInFrequency = (id) => {
    var userId = localStorage.getItem("userid");
    setIsSaving(true);
    axios
      .post(process.env.REACT_APP_SERVER + `user/setServicePlanID?nUserID=${userId}&nServicePlanID=${id}`, {}, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        getServicePlan();
        setIsSaving(false);
        setSuccess("Your Check In Dates have been Saved!")
        profileDetailGet();
        setTimeout(() => {
          setShowPlanModal(false);
        }, [500])
      })
      .catch((err) => {
        console.log(err);
        setIsSaving(false);
      })
      .finally(() => {
        setIsSaving(false);
      })
  }

  const FeatureList = ({ features }) => (
    <div
      className="text-start p-2"
      style={{
        border: "1px solid #000",
        fontSize: "14px",
        lineHeight: "1.5",
        textAlign: "left"
      }}
    >
      {features.map((feature, idx) => (
        <div key={idx}>
          - {feature}
        </div>
      ))}
    </div>
  );

  const [showConfirmation, setShowConfirmation] = useState(false);
  const handleCloses = () => {
    setShowConfirmation(false);
  };
  const handleopen = () => {
    setShowConfirmation(true);
  };
  return (
    <div className={"mainDashboard-Container"}>

      <Modal show={shows} onHide={handleCloseModel}>
        <Modal.Header style={{ backgroundColor: "#0069d9", color: "white" }}>
          <Modal.Title>New User Checking In</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          You will not be allowed to use the Check In(Keep In Touch) feature
          until you have selected a Service Plan
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ backgroundColor: "#0069d9" }}
            onClick={handleCloseModel}
          >
            Ok
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={suspendChekdIn} onHide={() => setSuspendChekdIn(false)} centered>
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#0069d9", color: "white" }}
        >
          <Modal.Title>Suspend Check In Service</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Check
              type="radio"
              name="checkin"
              id="enable"
              label="Enable Check In"
              checked={checkInOnOff === 1}
              onChange={() => setCheckInOnOff(1)}
              className="mb-3"
            />

            <Form.Check
              type="radio"
              name="checkin"
              id="disable"
              label="Disable Check In"
              checked={checkInOnOff === 0}
              onChange={() => setCheckInOnOff(0)}
            />
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setSuspendChekdIn(false)}>
            Cancel
          </Button>

          <Button
            style={{ backgroundColor: "#0069d9" }}
            onClick={handleSuspendCheckIn}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={openConformModel} onHide={() => setOpenConformModel(false)}>
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#0069d9", color: "white" }}
        >
          <Modal.Title> {modalMessage}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalMessage}
        </Modal.Body>
        <Modal.Footer>
          <Button className="btngenie" onClick={() => setOpenConformModel(false)}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal show={openRequiredModel} onHide={handleServicePlan}>
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#0069d9", color: "white" }}
        >
          <Modal.Title>Activate Service Plan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isChekIn ? (
            <p className="mb-2">
              You cannot Check In at this time. You do not have any Check In Dates in the system.
            </p>
          ) : (
            <>
              <p className="mb-2">
                You must subscribe to a Check In Plan.
              </p>
              <p className="mb-0">
                Click the “Purchase Check In Plan” button. The Check In Plan is a yearly subscription.
              </p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="btngenie" onClick={redirectServicePlan} disabled={isButtonDisabled}>
            Activate Service Plan
          </Button>
          <Button className="btngenie" onClick={handleServicePlan}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={openActiveModel} onHide={handleActivePlan}>
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#0069d9", color: "white" }}
        >
          <Modal.Title>Activate Service Plan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className='text-dark'>The following Email Address will be activated</p>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className='font-weight-bold'>Email:</label>
              <input
                type="email"
                className="form-control"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                readOnly
              />
              {errors.email && <div className="text-danger">{errors.email}</div>}
            </div>
            <div className="mb-3">
              <label className='font-weight-bold'>Enter Code:</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter Code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
              {errors.code && <div className="text-danger">{errors.code}</div>}
            </div>
            <Modal.Footer>
              <Button type="submit" className="btngenie">
                Submit
              </Button>
              <Button className="btngenie" onClick={handleActivePlan}>
                Close
              </Button>
            </Modal.Footer>
          </form>
        </Modal.Body>

      </Modal>

      <Modal show={openNewUserModel} onHide={handleNewUser}>
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#0069d9", color: "white" }}
        >
          <Modal.Title>Two Factor Authentication</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Sorry, as a new user you will not be allowed to turn on Two Factor
          Authentication. Once you have selected a Service Plan you will be
          able to turn on Two Factor Authentication.
        </Modal.Body>
        <Modal.Footer>
          <Button className="btngenie" onClick={handleNewUser}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showNextCheckInModal} onHide={handleNextCheckInModal} centered>
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#0069d9", color: "white" }}
        >
          <Modal.Title>Checking In</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p>
            Sorry {localStorage.getItem("name")}, your next scheduled check-in date is:
          </p>

          <p>
            {moment(currentUser?.nextcheckindate).format("MMMM DD, YYYY")}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btngenie" onClick={handleNextCheckInModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showPlanModal}
        onHide={() => handleCancel()}
        dialogClassName="modal-shift-left"
      >
        <Modal.Header style={{ backgroundColor: "#0069d9", color: "white" }} closeButton>
          <Modal.Title >Choose Your CheckIn Frequency</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">{
          // servicePlan ? <>
          //   <div
          //     className="d-flex align-items-center justify-content-between gap-3 p-2"
          //     style={{
          //       border: "1px solid #dee2e6",
          //       borderRadius: "6px",
          //     }}
          //   >
          //     {/* Left */}
          //     <div className="d-flex align-items-center gap-2 flex-grow-1">
          //       <strong>Custom Check In:</strong>

          //       <select
          //         className="form-select"
          //         style={{ maxWidth: "260px" }}
          //         value={dropdownValue}
          //         onChange={(e) => setDropdownValue(e.target.value)}
          //       >
          //         {dropdownOptions.map((opt) => (
          //           <option key={opt.id} value={opt.id}>
          //             {opt.shortdescription}
          //           </option>
          //         ))}
          //       </select>
          //     </div>

          //     {/* Right – PRICE */}
          //     <div
          //       className="fw-semibold text-nowrap"
          //       style={{ color: "#00000", fontWeight: "bold" }}
          //     >
          //       {selectedPlan?.yearlyCheckInRate
          //         ? `$${selectedPlan.yearlyCheckInRate}/Year`
          //         : `$${dropdownOptions[0]?.yearlyCheckInRate}/Year`}
          //       {/* FREE */}
          //     </div>
          //   </div>
          //   <button
          //     className="btn btn-secondary p-1 mt-2 d"
          //     style={{
          //       display: "flex",
          //       justifyContent: "start",
          //       alignItems: "center"
          //     }}
          //     onClick={() => {
          //       setDescType("custom");
          //       setShowDescModal(true);
          //     }}
          //   >
          //     View Custom Check In Description
          //   </button>

          //   {/* <FeatureList features={basicFeatures} /> */}
          // </>
          //   :
          <>
            {/* OPTION 1 */}
            <div
              className="d-flex flex-column gap-2 p-2"
              style={{ border: "2px solid #dee2e6" }}
            >
              {/* FIRST LINE */}
              <div className="d-flex align-items-center justify-content-between gap-3">
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="checkinOption"
                    checked={selectedOption === 1}
                    onChange={() => setSelectedOption(1)}
                  />

                  <div className="d-flex align-items-center gap-2">
                    <strong>Basic Check In:</strong>
                    <div
                      className="px-1 ms-3"
                      style={{ border: "2px solid #dee2e6" }}
                    >
                      Check In Every Other Day
                    </div>
                  </div>
                </div>

                <div className="fw-bold text-nowrap" style={{ color: "#000", fontWeight: "bold" }}>
                  {/* {yearlyCheckInRate ? `$${yearlyCheckInRate}/Year` : "--"} */}
                  FREE!!!
                </div>
              </div>

              {/* SECOND LINE */}
              <div className="fw-bold" style={{ color: "#000", textAlign: "start" }}>
                Basic Check In Plan is a Free service that only sends Emails
              </div>
            </div>
            {/* <button
              className="btn btn-secondary p-1 mt-2"
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center"
              }}
              onClick={() => {
                setDescType("basic");
                setShowDescModal(true);
              }}
            >
              View Basic Description
            </button> */}
            {/* <FeatureList features={basicFeatures} /> */}

            {/* OPTION 2 */}
            <div
              className="d-flex flex-column gap-2 p-2 mt-2"
              style={{ border: "2px solid #dee2e6" }}
            >
              {/* FIRST LINE */}
              <div className="d-flex align-items-center justify-content-between gap-3">
                {/* LEFT */}
                <div className="d-flex align-items-center gap-2 flex-grow-1">
                  <input
                    type="radio"
                    name="checkinOption"
                    checked={selectedOption === 2}
                    onChange={() => setSelectedOption(2)}
                  />

                  <strong>Custom Check In:</strong>

                  <select
                    className="form-select"
                    style={{ maxWidth: "260px" }}
                    disabled={selectedOption !== 2}
                    value={dropdownValue}
                    onChange={(e) => setDropdownValue(e.target.value)}
                  >
                    {dropdownOptions.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.shortdescription}
                      </option>
                    ))}
                  </select>
                </div>

                {/* RIGHT – PRICE */}
                <div className="d-flex align-items-center justify-content-between gap-3">
                  <div className="fw-bold text-nowrap" style={{ color: "#000", fontWeight: "bold" }}>
                    {selectedPlan?.yearlyCheckInRate
                      ? `$${selectedPlan.yearlyCheckInRate}/Year`
                      : `$${dropdownOptions[0]?.yearlyCheckInRate}/Year`}
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-end justify-content-end gap-1">
                {/* SECOND LINE – STARTS FROM LEFT EDGE */}
                <Button variant="primary" style={{
                  height: "25px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }} onClick={() => {
                  setPaymentModal(true)
                  stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
                  setStripePromises(stripePromise)
                }
                }>
                  Payment
                </Button>
              </div>
              <div className="fw-bold" style={{ color: "#000", textAlign: "start" }}>
                Custom Check In Plan is a Paid service that allows Text and/of Email
              </div>
            </div>
            {/* <button
              className="btn btn-secondary p-1 mt-2"
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center"
              }}
              onClick={() => {
                setDescType("custom");
                setShowDescModal(true);
              }}
            >
              View Custom Check In Description
            </button> */}
            {/* <FeatureList features={customFeatures} /> */}
          </>
        }
          {success && <Alert variant="success" className="mt-1">
            {success}
          </Alert>}

        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <Button variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="primary" disabled={selectedOption === null || isSaving} style={{ cursor: selectedOption === null || isSaving ? "not-allowed" : "pointer" }} onClick={() => handleSave()}>
            {isSaving ? "Saving..." : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDescModal}
        onHide={() => setShowDescModal(false)}
        style={{ border: "2px solid black" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{descriptions[descType]?.title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <ul className="mb-0 ml-2">
            {descriptions[descType]?.body.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => setShowDescModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>


      <Modal
        show={paymentModal}
        className={"checkin-dates-modal"}
        onHide={() => {
          setPaymentModal(false);
        }}
        centered
      >
        <Modal.Header style={{ backgroundColor: "#0069d9", color: "white" }} closeButton>
          <Modal.Title >Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Elements stripe={stripePromises}>
            <div className="common-font-section">
              <Container>
                <Form onSubmit={handlePaymentSubmit}>
                  <Form.Group as={Row} controlId="formPlaintextService">
                    <Col md={3}>
                      <Form.Label>Email:</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Control
                        type="email"
                        value={paymentEmail}
                        onChange={(e) => setPaymentEmail(e.target.value)}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="formPlaintextService2">
                    <Col md={3}>
                      <Form.Label>Full Name:</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Control
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group controlId="formBasicCheckbox" className="from-group-section active-status">
                    <Form.Label className="mb-2">Card Number:</Form.Label>
                    <div className="cardNumber_field ">
                      <CardNumberElement
                        className="data-card"
                        options={{
                          style: {
                            base: {
                              fontSize: "17px",
                              color: "black",
                              border: "1px solid red",
                              "::placeholder": {
                                color: "gray",
                              },
                            },
                          },
                        }}
                        onChange={handleChange}

                      />
                      <div className="cardPlaceholder">
                        {cardType == 'all' || cardType == 'visa' ?
                          <span className="visa">
                            <svg width="24px" height="16px" viewBox="0 0 24 16" version="1.1">
                              <g id="319" stroke="none" strokeWidth="1" fill="none"
                                fillRule="evenodd">
                                <g id="New-Icons" transform="translate(-80.000000, -280.000000)"
                                  fillRule="nonzero">
                                  <g id="Card-Brands"
                                    transform="translate(40.000000, 200.000000)">
                                    <g id="Color" transform="translate(0.000000, 80.000000)">
                                      <g id="Visa" transform="translate(40.000000, 0.000000)">
                                        <rect id="Container" strokeOpacity="0.2"
                                          stroke="#000000" strokeWidth="0.5"
                                          fill="#FFFFFF" x="0.25" y="0.25" width="23.5"
                                          height="15.5" rx="2"></rect>
                                        <path
                                          d="M2.78773262,5.91443732 C2.26459089,5.62750595 1.6675389,5.39673777 1,5.23659312 L1.0280005,5.1118821 L3.76497922,5.1118821 C4.13596254,5.12488556 4.43699113,5.23650585 4.53494636,5.63071135 L5.12976697,8.46659052 L5.31198338,9.32072617 L6.97796639,5.1118821 L8.77678896,5.1118821 L6.10288111,11.2775284 L4.30396552,11.2775284 L2.78773262,5.91443732 L2.78773262,5.91443732 Z M10.0999752,11.2840738 L8.39882877,11.2840738 L9.46284763,5.1118821 L11.163901,5.1118821 L10.0999752,11.2840738 Z M16.2667821,5.26277458 L16.0354292,6.59558538 L15.881566,6.53004446 C15.5737466,6.40524617 15.1674138,6.28053516 14.6143808,6.29371316 C13.942741,6.29371316 13.6415263,6.56277129 13.6345494,6.82545859 C13.6345494,7.11441463 13.998928,7.3048411 14.5939153,7.58725177 C15.5740257,8.02718756 16.0286384,8.56556562 16.0218476,9.26818871 C16.0080799,10.5486366 14.8460128,11.376058 13.0610509,11.376058 C12.2978746,11.3694253 11.5627918,11.2180965 11.163808,11.0475679 L11.4018587,9.66204513 L11.6258627,9.76066195 C12.1788958,9.99070971 12.5428092,10.0889775 13.221984,10.0889775 C13.7117601,10.0889775 14.2368857,9.89837643 14.2435835,9.48488392 C14.2435835,9.21565125 14.0198586,9.01850486 13.3617074,8.7164581 C12.717789,8.42086943 11.8568435,7.92848346 11.8707973,7.04197926 C11.8780532,5.84042483 13.0610509,5 14.7409877,5 C15.3990458,5 15.9312413,5.13788902 16.2667821,5.26277458 Z M18.5277524,9.0974856 L19.941731,9.0974856 C19.8717762,8.78889347 19.549631,7.31147374 19.549631,7.31147374 L19.4307452,6.77964104 C19.3467437,7.00942698 19.1998574,7.38373457 19.2069273,7.37055657 C19.2069273,7.37055657 18.6678479,8.74290137 18.5277524,9.0974856 Z M20.6276036,5.1118821 L22,11.2839865 L20.4249023,11.2839865 C20.4249023,11.2839865 20.2707601,10.5748181 20.221922,10.3581228 L18.0377903,10.3581228 C17.9746264,10.5221933 17.6807607,11.2839865 17.6807607,11.2839865 L15.8957988,11.2839865 L18.4226343,5.62399144 C18.5977072,5.22341512 18.9059917,5.1118821 19.3117663,5.1118821 L20.6276036,5.1118821 L20.6276036,5.1118821 Z"
                                          id="Shape" fill="#171E6C"></path>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </span>
                          : null}
                        {cardType == 'all' || cardType == 'mastercard' ?
                          <span className="master">
                            <svg height="16" viewBox="0 0 24 16" width="24">
                              <g fill="none" fillRule="evenodd">
                                <rect fill="#252525" height="16" rx="2" width="24" />
                                <circle cx="9" cy="8" fill="#eb001b" r="5" />
                                <circle cx="15" cy="8" fill="#f79e1b" r="5" />
                                <path
                                  d="m12 3.99963381c1.2144467.91220633 2 2.36454836 2 4.00036619s-.7855533 3.0881599-2 4.0003662c-1.2144467-.9122063-2-2.36454837-2-4.0003662s.7855533-3.08815986 2-4.00036619z"
                                  fill="#ff5f00"
                                />
                              </g>
                            </svg>
                          </span>
                          : null}
                        {cardType == 'all' || cardType == 'amex' ?
                          <span className="express">
                            <svg height="16" viewBox="0 0 24 16" width="24">
                              <g fill="none" fillRule="evenodd">
                                <rect fill="#016fd0" height="16" rx="2" width="24" />
                                <path
                                  d="m13.7640663 13.3938564v-5.70139231l10.1475359.00910497v1.57489503l-1.1728619 1.25339231 1.1728619 1.2648839v1.6083094h-1.8726188l-.9951823-1.0981657-.9881105 1.1023204z"
                                  fill="#fffffe"
                                />
                                <path
                                  d="m14.4418122 12.7687956v-4.448884h3.7722872v1.02488398h-2.550895v.69569062h2.4900774v1.0078232h-2.4900774v.6833149h2.550895v1.0371713z"
                                  fill="#016fd0"
                                />
                                <path
                                  d="m18.1952707 12.7687956 2.087337-2.2270055-2.0874254-2.2217901h1.6156464l1.2754917 1.41003315 1.2791161-1.41003315h1.5461657v.03500552l-2.0428729 2.18678458 2.0428729 2.1638895v.063116h-1.5617237l-1.2981216-1.4241768-1.2847735 1.4241768z"
                                  fill="#016fd0"
                                />
                                <path
                                  d="m14.2373481 2.6319558h2.4460552l.8591381 1.95085083v-1.95085083h3.0198453l.5207514 1.46156906.5225194-1.46156906h2.3059447v5.70139227h-12.1865193z"
                                  fill="#fffffe"
                                />
                                <g fill="#016fd0">
                                  <path
                                    d="m14.7004641 3.25135912-1.9740111 4.44517127h1.3539006l.3724199-.89016575h2.0179447l.3721547.89016575h1.3875801l-1.96579-4.44517127zm.1696353 2.55743646.592-1.41507182.5915581 1.41507182z" />
                                  <path
                                    d="m18.2119779 7.69573481v-4.44508288l1.903116.00654144.9792707 2.73272928.9856354-2.73927072h1.8316022v4.44508288l-1.1786077.01043094v-3.05334807l-1.1125746 3.04291713h-1.0758011l-1.1356464-3.05334807v3.05334807z" />
                                </g>
                              </g>
                            </svg>
                          </span>
                          : null}
                        {cardType == 'all' || cardType == 'diners' ?
                          <span className="dinners">
                            <svg width="24px" height="16px" viewBox="0 0 24 16" version="1.1">
                              <g id="319" stroke="none" strokeWidth="1" fill="none"
                                fillRule="evenodd">
                                <g id="New-Icons" transform="translate(-320.000000, -280.000000)"
                                  fillRule="nonzero">
                                  <g id="Card-Brands"
                                    transform="translate(40.000000, 200.000000)">
                                    <g id="Color" transform="translate(0.000000, 80.000000)">
                                      <g id="Diners-Club"
                                        transform="translate(280.000000, 0.000000)">
                                        <path
                                          d="M21.9972414,15.749927 L21.999381,15.7499362 C22.9544683,15.7581106 23.73806,14.9772525 23.75,14.0041555 L23.7500083,2.00630219 C23.7461702,1.53568921 23.5588633,1.08617106 23.2297297,0.756801782 C22.9014319,0.428268884 22.4589161,0.246148853 21.9972414,0.250070854 L2.00063,0.250061791 C1.54108393,0.246148853 1.09856813,0.428268884 0.77027028,0.756801782 C0.441136651,1.08617106 0.253829819,1.53568921 0.25,2.00426336 L0.249991686,13.9936957 C0.253829819,14.4643086 0.441136651,14.9138268 0.77027028,15.2431961 C1.09856813,15.571729 1.54108393,15.753849 2.00275862,15.749927 L21.9972414,15.749927 Z M21.996203,16.249927 C21.9958359,16.249924 21.9954688,16.249921 21.9951018,16.2499178 L21.9972414,16.249927 L21.996203,16.249927 Z"
                                          id="shape" strokeOpacity="0.2" stroke="#000000"
                                          strokeWidth="0.5" fill="#FFFFFF"></path>
                                        <path
                                          d="M10.0021142,2.05179033 L10.0021142,2.03579033 L14.0021142,2.03579033 L14.0021142,2.05179033 C17.1375481,2.28122918 19.5642283,4.89197286 19.5642283,8.03579033 C19.5642283,11.1796078 17.1375481,13.7903515 14.0021142,14.0197903 L14.0021142,14.0357903 L10.0021142,14.0357903 L10.0021142,14.0197903 C6.86668021,13.7903515 4.44,11.1796078 4.44,8.03579033 C4.44,4.89197286 6.86668021,2.28122918 10.0021142,2.05179033 Z"
                                          id="shape" fill="#0165AC"></path>
                                        <path
                                          d="M11.6021142,11.4277903 C13.0374002,10.9175027 13.9961556,9.55908923 13.9961556,8.03579033 C13.9961556,6.51249143 13.0374002,5.15407792 11.6021142,4.64379033 L11.6021142,11.4277903 L11.6021142,11.4277903 Z M9.20211417,4.64379033 C7.76682809,5.15407792 6.80807271,6.51249143 6.80807271,8.03579033 C6.80807271,9.55908923 7.76682809,10.9175027 9.20211417,11.4277903 L9.20211417,4.64379033 L9.20211417,4.64379033 Z M10.4021142,13.2357903 C7.53023347,13.2357903 5.20211417,10.907671 5.20211417,8.03579033 C5.20211417,5.16390963 7.53023347,2.83579033 10.4021142,2.83579033 C13.2739949,2.83579033 15.6021142,5.16390963 15.6021142,8.03579033 C15.6021142,10.907671 13.2739949,13.2357903 10.4021142,13.2357903 Z"
                                          id="shape" fill="#FFFFFF"></path>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </span>
                          : null}

                        {cardType == 'discover' ?
                          <span className="discover">
                            <svg width="24px" height="16px" viewBox="0 0 24 16" version="1.1">
                              <g id="319" stroke="none" strokeWidth="1" fill="none"
                                fillRule="evenodd">
                                <g id="New-Icons" transform="translate(-280.000000, -280.000000)"
                                  fillRule="nonzero">
                                  <g id="Card-Brands"
                                    transform="translate(40.000000, 200.000000)">
                                    <g id="Color" transform="translate(0.000000, 80.000000)">
                                      <g id="Discover"
                                        transform="translate(240.000000, 0.000000)">
                                        <path
                                          d="M21.9972414,15.749927 L21.999381,15.7499362 C22.9544683,15.7581106 23.73806,14.9772525 23.75,14.0041555 L23.7500083,2.00630219 C23.7461702,1.53568921 23.5588633,1.08617106 23.2297297,0.756801782 C22.9014319,0.428268884 22.4589161,0.246148853 21.9972414,0.250070854 L2.00063,0.250061791 C1.54108393,0.246148853 1.09856813,0.428268884 0.77027028,0.756801782 C0.441136651,1.08617106 0.253829819,1.53568921 0.25,2.00426336 L0.249991686,13.9936957 C0.253829819,14.4643086 0.441136651,14.9138268 0.77027028,15.2431961 C1.09856813,15.571729 1.54108393,15.753849 2.00275862,15.749927 L21.9972414,15.749927 Z M21.996203,16.249927 C21.9958359,16.249924 21.9954688,16.249921 21.9951018,16.2499178 L21.9972414,16.249927 L21.996203,16.249927 Z"
                                          id="shape" strokeOpacity="0.2" stroke="#000000"
                                          strokeWidth="0.5" fill="#FFFFFF"></path>
                                        <path
                                          d="M12.6124138,15.9999283 L21.9972414,15.9999283 C22.5240217,16.0043364 23.0309756,15.7992919 23.4065697,15.4299059 C23.7821638,15.06052 23.9956285,14.5570537 24,14.0302731 L24,11.6716524 C20.4561668,13.7059622 16.6127929,15.1667795 12.6124138,15.9999283 L12.6124138,15.9999283 Z"
                                          id="shape" fill="#F27712"></path>
                                        <path
                                          d="M23.1724138,9.29647999 L22.32,9.29647999 L21.36,8.03027309 L21.2689655,8.03027309 L21.2689655,9.29647999 L20.5737931,9.29647999 L20.5737931,6.1516524 L21.6,6.1516524 C22.4027586,6.1516524 22.8662069,6.48268688 22.8662069,7.07854895 C22.8662069,7.56682481 22.5765517,7.88130757 22.0551724,7.98061792 L23.1724138,9.29647999 Z M22.1462069,7.10337654 C22.1462069,6.79716964 21.9144828,6.63992826 21.4841379,6.63992826 L21.2689655,6.63992826 L21.2689655,7.5916524 L21.4675862,7.5916524 C21.9144828,7.5916524 22.1462069,7.42613516 22.1462069,7.10337654 L22.1462069,7.10337654 Z M18.1406897,6.1516524 L20.1103448,6.1516524 L20.1103448,6.68130757 L18.8358621,6.68130757 L18.8358621,7.38475585 L20.0606897,7.38475585 L20.0606897,7.92268688 L18.8358621,7.92268688 L18.8358621,8.77510068 L20.1103448,8.77510068 L20.1103448,9.30475585 L18.1406897,9.30475585 L18.1406897,6.1516524 Z M15.9062069,9.37923861 L14.4,6.14337654 L15.1613793,6.14337654 L16.1131034,8.26199723 L17.0731034,6.14337654 L17.817931,6.14337654 L16.2951724,9.37923861 L15.9227586,9.37923861 L15.9062069,9.37923861 Z M9.60827586,9.37096274 C8.54896552,9.37096274 7.72137931,8.65096274 7.72137931,7.71579033 C7.72137931,6.8054455 8.56551724,6.06889378 9.62482759,6.06889378 C9.92275862,6.06889378 10.1710345,6.12682481 10.4772414,6.25923861 L10.4772414,6.98751447 C10.2453534,6.75969251 9.93335245,6.63192067 9.60827586,6.6316524 C8.9462069,6.6316524 8.44137931,7.1116524 8.44137931,7.71579033 C8.44137931,8.35303171 8.93793103,8.80820412 9.64137931,8.80820412 C9.95586207,8.80820412 10.1958621,8.70889378 10.4772414,8.46061792 L10.4772414,9.18889378 C10.1627586,9.32130757 9.89793103,9.37096274 9.60827586,9.37096274 L9.60827586,9.37096274 Z M7.5062069,8.33647999 C7.5062069,8.94889378 7.00137931,9.37096274 6.27310345,9.37096274 C5.74344828,9.37096274 5.36275862,9.18889378 5.04,8.77510068 L5.49517241,8.38613516 C5.65241379,8.66751447 5.91724138,8.80820412 6.24827586,8.80820412 C6.56275862,8.80820412 6.7862069,8.6178593 6.7862069,8.36958343 C6.7862069,8.22889378 6.72,8.12130757 6.57931034,8.03854895 C6.42504922,7.96369158 6.26441119,7.90275992 6.09931034,7.85647999 C5.44551724,7.64958343 5.22206897,7.42613516 5.22206897,6.98751447 C5.22206897,6.47441102 5.70206897,6.0854455 6.33103448,6.0854455 C6.72827586,6.0854455 7.08413793,6.20958343 7.38206897,6.44130757 L7.01793103,6.85510068 C6.87360928,6.69688076 6.66932728,6.60675635 6.45517241,6.60682481 C6.15724138,6.60682481 5.94206897,6.75579033 5.94206897,6.95441102 C5.94206897,7.11992826 6.0662069,7.21096274 6.48,7.3516524 C7.27448276,7.59992826 7.5062069,7.8316524 7.5062069,8.34475585 L7.5062069,8.33647999 Z M4.08827586,6.1516524 L4.78344828,6.1516524 L4.78344828,9.30475585 L4.08827586,9.30475585 L4.08827586,6.1516524 Z M1.8537931,9.30475585 L0.827586207,9.30475585 L0.827586207,6.1516524 L1.8537931,6.1516524 C2.97931034,6.1516524 3.75724138,6.79716964 3.75724138,7.72406619 C3.75724138,8.19579033 3.52551724,8.64268688 3.12,8.94061792 C2.77241379,9.18889378 2.38344828,9.30475585 1.84551724,9.30475585 L1.8537931,9.30475585 Z M2.66482759,6.9378593 C2.43310345,6.75579033 2.16827586,6.68958343 1.71310345,6.68958343 L1.52275862,6.68958343 L1.52275862,8.77510068 L1.71310345,8.77510068 C2.16,8.77510068 2.44137931,8.69234206 2.66482759,8.52682481 C2.90482759,8.32820412 3.04551724,8.03027309 3.04551724,7.72406619 C3.04551724,7.4178593 2.90482759,7.12820412 2.66482759,6.9378593 Z"
                                          id="shape" fill="#000000"></path>
                                        <path
                                          d="M12.4137931,6.06889378 C11.5034483,6.06889378 10.7586207,6.79716964 10.7586207,7.69923861 C10.7586207,8.65923861 11.4703448,9.37923861 12.4137931,9.37923861 C13.3406897,9.37923861 14.0689655,8.65096274 14.0689655,7.72406619 C14.0689655,6.79716964 13.3489655,6.06889378 12.4137931,6.06889378 Z"
                                          id="shape" fill="#F27712"></path>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </span>
                          : null}

                        {cardType == 'jcb' ?
                          <span className="jcb">
                            <svg height="16" viewBox="0 0 23 16" width="23">
                              <g fill="none">
                                <path
                                  d="m.20535714 16h4.51785715c1.0278125 0 2.25892857-1.1946667 2.25892857-2.1333333v-13.8666667h-4.51785715c-1.0278125 0-2.25892857 1.19466667-2.25892857 3.2z"
                                  fill="#047ab1"
                                />
                                <path
                                  d="m2.76924107 10.816c-.86733559.0001606-1.73039558-.1147397-2.56388393-.3413333v-1.17333337c.64678874.37770431 1.38610045.59084099 2.14598215.61866667.8696875 0 1.35535714-.576 1.35535714-1.36533333v-3.22133334h2.14598214v3.22133334c0 1.25866666-.70026786 2.26133333-3.0834375 2.26133333z"
                                  fill="#fff"
                                />
                                <path
                                  d="m8.11160714 16h4.51785716c1.0278125 0 2.2589286-1.1946667 2.2589286-2.1333333v-13.8666667h-4.5178572c-1.02781249 0-2.25892856 1.19466667-2.25892856 3.2z"
                                  fill="#d42d06"
                                />
                                <path
                                  d="m8.11160714 6.08c.65508929-.59733333 1.78455357-.97066667 3.61428576-.88533333.9939285.04266666 2.0330357.32 2.0330357.32v1.184c-.5943231-.3394747-1.2623758-.54734656-1.9539732-.608-1.3892411-.11733334-2.23633933.61866666-2.23633933 1.90933333s.84709823 2.0266667 2.23633933 1.92c.6920185-.06606555 1.3596342-.27744592 1.9539732-.61866667v1.17333337s-1.0391072.288-2.0330357.3306666c-1.82973219.0853334-2.95919647-.288-3.61428576-.8853333z"
                                  fill="#fff"
                                />
                                <path
                                  d="m16.0178571 16h4.5178572c1.0278125 0 2.2589286-1.1946667 2.2589286-2.1333333v-13.8666667h-4.5178572c-1.0278125 0-2.2589286 1.19466667-2.2589286 3.2z"
                                  fill="#67b637"
                                />
                                <path
                                  d="m21.6651786 9.28c0 .8533333-.7002679 1.3866667-1.6377232 1.3866667h-4.0095983v-5.33333337h3.6481697l.2597768.01066667c.8245089.04266667 1.4344196.50133333 1.4344196 1.29066667 0 .61866666-.4179018 1.152-1.1746428 1.28v.032c.8358035.05333333 1.4795982.55466666 1.4795982 1.33333333zm-2.880134-3.104c-.0486104-.00686658-.0976798-.01043129-.1468303-.01066667h-1.3553572v1.344h1.5021875c.2823661-.064.5195536-.30933333.5195536-.672 0-.36266666-.2371875-.608-.5195536-.66133333zm.1694197 2.176c-.059755-.00886168-.1202559-.01243275-.1807143-.01066667h-1.4908929v1.46133334h1.4908929l.1807143-.02133334c.2823661-.064.5195536-.34133333.5195536-.71466666 0-.37333334-.2258929-.64-.5195536-.71466667z"
                                  fill="#fff"
                                />
                              </g>
                            </svg>
                          </span>
                          : null}

                        {cardType == 'unionpay' ?
                          <span className="unionpay">
                            <svg height="16" viewBox="0 0 24 16" width="24">
                              <g fill="none">
                                <path
                                  d="m4.54588254.00006676h5.79377466c.8087588 0 1.3117793.72566459 1.1231113 1.61890981l-2.69741608 12.74856503c-.19036262.8901361-1.00010994 1.6164225-1.80943362 1.6164225h-5.79320976c-.80762905 0-1.31177937-.7262864-1.12311135-1.6164225l2.69854581-12.74856503c.18866803-.89324522.9979917-1.61890981 1.80773904-1.61890981"
                                  fill="#dd2423"
                                />
                                <path
                                  d="m9.85756516.00006676h6.66269264c.8086174 0 .4439911.72566459.2537697 1.61890981l-2.6969924 12.74856503c-.1892329.8901361-.1302036 1.6164225-.9405158 1.6164225h-6.66269248c-.81031221 0-1.31177939-.7262864-1.12141672-1.6164225l2.69685116-12.74856503c.19149238-.89324522.99912144-1.61890981 1.8083039-1.61890981"
                                  fill="#16315e"
                                />
                                <path
                                  d="m16.2559813.00006676h5.7937745c.8098886 0 1.3129092.72566459 1.1226878 1.61890981l-2.6969924 12.74856503c-.1903626.8901361-1.0006749 1.6164225-1.8104222 1.6164225h-5.7910915c-.8103122 0-1.3129091-.7262864-1.1231113-1.6164225l2.697416-12.74856503c.1886681-.89324522.9974268-1.61890981 1.8077391-1.61890981"
                                  fill="#036862"
                                />
                                <path
                                  d="m6.05901135 4.08561434c-.59580116.00668457-.77175951 0-.8279645-.01461278-.02160646.11301588-.42365577 2.15460824-.42478553 2.15631824-.08656699.4130443-.14955043.7074763-.36349659.89759795-.12144798.1105286-.26323144.1638497-.42760986.1638497-.26421996 0-.41814822-.1444178-.44399122-.41832975l-.00494264-.09405035s.08049458-.55326485.08049458-.55637395c0 0 .42196112-1.86048711.49751306-2.10641713.00395412-.01399096.00508387-.02129736.00607239-.02798193-.82132725.00792821-.9669236 0-.97695012-.01461278-.00550753.02005371-.025843.13540142-.025843.13540142l-.43085788 2.09693437-.03699927.1778407-.07159782.5817131c0 .1725552.03078565.31339755.09207452.4324762.19629382.37760055.75622549.4341862 1.07297875.4341862.40812169 0 .79096525-.09544945 1.04967767-.26971465.44907509-.2921002.56656897-.74867195.67135315-1.15440985l.04857917-.20815445s.43467082-1.93230737.5085281-2.18367833c.00282441-.01399096.00395413-.02129736.00776704-.02798193zm1.47893982 1.55881086c-.10478422 0-.29627659.0279819-.46828081.12078865-.0624186.0352883-.12144796.07601755-.18372539.11659135l.056205-.22338905-.03078563-.03762015c-.36476761.08130305-.44639193.0921849-.78333945.14441785l-.02824374.0206755c-.03911752.3570805-.07385733.6255515-.21888878 1.32743145-.05521646.25867735-.11255121.519842-.17002718.7778975l.01553403.03280105c.34527946-.0200537.45006363-.0200537.75015309-.0146128l.02428961-.0290701c.03812903-.21499445.04307165-.2653619.12752039-.70079175.03968242-.20644445.1224365-.66006255.16324868-.8215804.07498704-.038242.14898558-.07586215.21959486-.07586215.16819135 0 .14771465.1615179.14121858.22587635-.00720213.1080413-.06849101.4609245-.13133325.76390655l-.04194194.19556255c-.02923223.14441785-.06128888.2847938-.09052111.427968l.01270966.02860375c.34033679-.0200537.44413246-.0200537.73476028-.0146128l.0341749-.0290701c.0525333-.3357831.06792611-.42563615.16113038-.9145426l.04688457-.22463265c.09108601-.43962715.13684082-.6625498.06792616-.8441214-.07286879-.2034908-.24769738-.2526146-.40826291-.2526146zm1.65214439.4602871c-.18090101.038242-.29627659.0637366-.41094606.08021485-.11368097.02005375-.22453757.038242-.39936616.06498025l-.01383941.0138355-.01270966.01103735c-.01821719.14332965-.0309269.26722735-.05507525.41288885-.02047669.150636-.05196844.3217921-.10323077.56772215-.03968243.18825615-.06015913.25385825-.08275412.32008215-.0220301.06622385-.04631967.1305823-.09094476.31572935l.01045019.0171001.00875554.01570095c.1633899-.00855005.27029237-.0146128.38016043-.01570095.10972684-.00435275.22340776 0 .39936611.00108815l.01539286-.0138355.01652257-.0152346c.02541932-.1669588.02923224-.21188535.04476626-.29334385.01539282-.0873658.04194194-.20830985.10704369-.53134565.03078568-.1517242.06510179-.30298205.09701718-.4578154.03318641-.1542115.06792612-.30609115.10097127-.45781535l-.00494263-.0183437zm.00385525-.620608c-.1643784-.10679765-.45288796-.07290845-.64706354.0746185-.19361063.14457325-.21564072.34977405-.05182718.4579708.16155403.10384405.45119334.0729085.64367421-.0758621.19318708-.14768235.21733543-.3510177.05521651-.4567272zm.99410809 2.473369c.3325698 0 .6734715-.1008904.9300657-.400297.1974235-.2428209.2879446-.60409865.3192952-.7528692.1021011-.4931037.0225949-.7233328-.0772466-.8635533-.1516687-.21375085-.4197016-.28230655-.697761-.28230655-.1672028 0-.5654392.01818825-.87654364.33391765-.22340786.22774175-.32663863.5367866-.38891601.83308405-.06284224.3018939-.13514621.84536505.31887154 1.0476122.14008884.0662239.34203141.08441215.47223481.08441215zm-.0259841-1.10948335c.0766817-.3734032.1672028-.6868008.3982364-.6868008.1810422 0 .1941755.23318275.1136809.6078296-.0144042.0831685-.0804945.3923688-.1698859.5240393-.0624186.09715945-.1362759.15607695-.2179003.15607695-.0242896 0-.1687562 0-.1710157-.23613635-.0011297-.11659135.0204767-.23567.0468846-.3650087zm2.1066988 1.06146325.0259841-.0290701c.0368581-.21499445.0429305-.2655174.1245549-.70079175.0408121-.20644445.1252608-.66006255.1649433-.82158045.0751282-.0383974.1478558-.07601755.2207245-.07601755.1670616 0 .1467262.1615179.140089.2258763-.0060725.1081968-.0673613.4609245-.1313334.76390655l-.0396824.1955626c-.030362.14457325-.0634071.2847938-.0926394.42812345l.0127097.02860375c.3414665-.02005375.441308-.02005375.7336305-.0146128l.0353047-.0290701c.0512623-.33593855.0651017-.42579165.1611304-.9145426l.0457548-.2247881c.0915096-.43962715.1378292-.66239435.0700444-.84396595-.0749871-.2034908-.2509454-.2526146-.4092515-.2526146-.1049254 0-.2974063.02782645-.468422.12078865-.0611476.0352883-.1224365.0758621-.1825956.11659135l.0523921-.22338905-.0281025-.0377756c-.3646263.0814585-.4479453.09234035-.7844692.1445733l-.025843.0206755c-.0408122.35708045-.0739986.62539605-.21903 1.32743145-.0552164.25867735-.1125512.51984195-.1698859.7778975l.0153928.03280105c.3458442-.02005375.4490751-.02005375.7485997-.0146128zm2.5088186.01453505c.0214652-.1153477.1489856-.7990394.1501153-.7990394 0 0 .1085971-.50165375.1152345-.519842 0 0 .0341748-.0522329.0683497-.07290845h.0502738c.4743532 0 1.0099953 0 1.4298381-.3399804.2856852-.2331827.4809905-.57751585.5681223-.99600105.022595-.1026004.0392588-.22463269.0392588-.34666496 0-.16027425-.0292322-.3188385-.1136809-.44273624-.2140874-.32972035-.6404262-.3357831-1.132573-.33827039-.0015534 0-.2426136.00248729-.2426136.00248729-.629976.00855003-.8826161.00606275-.9864117-.00792821-.0087556.05052291-.0252782.14037599-.0252782.14037599s-.2256673 1.15130077-.2256673 1.15316622c0 0-.5400198 2.4477966-.5654392 2.5631443.5500464-.00730635.7755725-.00730635.8704714.0041973zm.4181482-2.0451678s.2399304-1.14896892.2388007-1.14461618l.0077669-.05891749.0033893-.04492654.0958874.01088185s.4948299.046792.5064099.04803565c.1953052.0831685.2757998.29754113.2195948.57736036-.0512623.2557237-.2019425.4707182-.3955532.5745622-.1594358.0879876-.3547411.095294-.5559775.095294h-.1302035zm1.4938667.99045135c-.0634072.2975411-.136276.8410123.3154822 1.0347094.1440429.0674675.2731167.0875212.4043088.08021485.1385355-.00823915.2669031-.08472305.3858092-.1947853-.0107326.04523745-.0214652.0904749-.0321978.1358678l.0204766.0290701c.324944-.01507915.4257741-.01507915.7778319-.0121255l.0319154-.0267383c.0514036-.332674.0998416-.65570975.2334344-1.2921431.0651017-.30484755.1300622-.6067414.1968587-.9103453l-.0104501-.03342285c-.3634967.0741521-.4606551.09000855-.8103124.1445733l-.026549.0237846c-.0035305.0309356-.0072021.0606275-.0105914.09031945-.0543692-.0966931-.1331691-.17923975-.2547583-.2306954-.1554817-.0673121-.5206729.01943185-.8346018.33407305-.2205834.2246327-.3264973.53243385-.3866564.8276432zm.7634275.01818825c.0778115-.3667187.1672028-.67700715.3988014-.67700715.1464436 0 .2235489.14877055.2078737.40247335-.0124272.06327025-.025843.1299605-.0418008.20535625-.0231597.10897405-.0482967.21701535-.0727275.32521215-.0248545.07399665-.0538043.143796-.0855784.1902771-.0595943.09296215-.2013777.150636-.2830021.150636-.0231599 0-.1660731 0-.1710157-.23193905-.0011298-.11550315.0204767-.23442635.0474494-.36500865zm3.9866711-1.21085565-.0281024-.0352883c-.3596838.08021485-.4247856.09296215-.755237.142086l-.0242897.02673825c-.0011296.00435275-.0021182.01103735-.0038128.0171001l-.0011298-.00606275c-.2460027.6247742-.2388006.4899946-.4390485.98185465-.0011298-.02238555-.0011298-.0363765-.0022595-.06016115l-.0501327-1.0662668-.0314917-.0352883c-.3767711.08021485-.3856679.09296215-.7336305.142086l-.0271139.02673825c-.003813.01274735-.003813.0267383-.0060724.0419729l.0022594.00544095c.0434954.2446864.0330452.19012165.0766818.5762722.0203354.1894998.0474494.3800878.0677848.5672558.0343162.3132421.0535219.4674536.0954638.94547815-.2349878.4268798-.2906279.5883977-.51686.9630446l.0015534.0037309-.1592946.27733195c-.0182171.0292256-.0347397.0492793-.0578996.05782935-.0254193.0138355-.0584644.01632275-.1043605.01632275h-.0882616l-.131192.4803564.4500635.00855005c.26422-.00124365.4302931-.1372669.5196844-.32008215l.283002-.53383295h-.004519l.0297972-.03762015c.1903626-.4511308 1.6384179-3.1855867 1.6384179-3.1855867zm-4.7501128 6.3087581h-.1909276l.7066579-2.57293795h.2344228l.0744221-.265051.0072022.29474295c-.0087556.1821934.121448.3437113.4634794.31697305h.3955532l.1361347-.49543555h-.1488443c-.0855785 0-.1252609-.02378465-.1203182-.0747739l-.0072022-.299873h-.7325008v.00155455c-.2368235.00544095-.9440462.0250283-1.0872418.0670012-.1732752.0491238-.3558709.1936971-.3558709.1936971l.071739-.26536195h-.6851925l-.1427719.52652655-.7161194 2.61226815h-.1389591l-.136276.4918601h1.3647364l-.0457548.1640051h.6724828l.0446251-.1640051h.1886681zm-.5599316-2.0501423c-.1097268.03342285-.313929.1347796-.313929.1347796l.1816071-.65757525h.5443977l-.1313333.47911275s-.1681914.01088185-.2807425.0436829zm.0104502.9394154s-.1710158.0236292-.283567.0516111c-.1108566.0369984-.3187303.1535897-.3187303.1535897l.1875382-.6843135h.5472221zm-.3050322 1.1167897h-.5460922l.158306-.5775158h.5443976zm1.315112-1.5959024h.7871525l-.1131162.4032506h-.7976024l-.1197535.4408708h.6979023l-.5284398.8190931c-.0369994.0601612-.0701858.0814585-.1070437.0984031-.0369994.0206755-.0855785.0449265-.1417835.0449265h-.1936107l-.133028.4828437h.5064098c.2632315 0 .4187131-.131826.5335239-.3048476l.3623669-.5459584.0778115.5543531c.0165225.1038439.0843074.1646269.1302034.1882561.0506975.0279819.1030897.0760176.1770882.0831685.0793648.0037309.1366995.0066846.1748285.0066846h.2488272l.1494092-.5403621h-.0981469c-.0563463 0-.1533633-.0104155-.1698859-.0298474-.0165226-.0236292-.0165226-.0600057-.0254194-.1153477l-.0789412-.5555967h-.3232494l.1417836-.1857688h.796049l.1224365-.4408708h-.7370197l.1148107-.4032506h.7347603l.1362759-.497301h-2.1905826zm-6.6483163 1.7081877.1837253-.6728098h.7550958l.1379705-.5004101h-.7558018l.1153756-.4141325h.7385731l.1368408-.4845537h-1.84798632l-.13401641.4845537h.41984283l-.1119863.4141325h-.42097264l-.13952389.5089601h.41970155l-.24487301.8901361c-.03304514.117835.01553408.1627615.04631971.2174817.03149175.0533211.06340718.0886094.13514621.1086631.07399857.0181883.12469597.0290701.19361067.0290701h.8512656l.1516688-.554353-.3773361.0570521c-.0728688 0-.2746701-.0096382-.25264-.0837903zm.0866093-3.22084395-.1913512.38070965c-.0409534.08316845-.0778114.1347796-.1109978.1585642-.0292322.02005375-.0871318.0284483-.1710157.0284483h-.0998415l-.13345158.48704095h.33158128c.1594357 0 .2818722-.0643584.3403368-.09653765.0628422-.0369983.0793647-.0158564.1279439-.0674675l.1119864-.1067977h1.0354146l.1374057-.50709465h-.7579202l.1323219-.2768656zm1.5286064 3.23062205c-.0176524-.027982-.0049427-.0772612.0220301-.1798616l.283002-1.0311339h1.0067472c.1467262-.0023318.25264-.0041973.3215547-.0096382.0739985-.0085501.1544932-.0376202.2421899-.0898531.0905212-.0547202.1368408-.1123941.1759583-.178618.0436366-.0660684.113681-.2106417.1738401-.4335643l.3557296-1.3048905-1.044735.0066846s-.3216959.0522329-.4633381.10990675c-.1429132.06435845-.3471154.2440646-.3471154.2440646l.0943341-.3577023h-.645369l-.9035164 3.29860265c-.0320566.1280949-.0535218.2210571-.0584645.2768655-.0016946.0601612.0689147.1197005.1146695.164627.0540867.0449266.1340164.0376202.2106981.0449266.0806358.0066846.1953053.0108818.3536113.0108818h.4959597l.1522336-.5658567-.4439912.0461702c-.0474494 0-.0817655-.027982-.0960286-.0516111zm.4876277-1.9074346h1.0574447l-.06722.2319391c-.0094616.0054409-.0320566-.0115037-.1396652.0024873h-.9156612zm.2118279-.77789745h1.0663414l-.0766816.27935285s-.5025969-.0054409-.5830915.01088185c-.3541763.06746755-.5610614.27577745-.5610614.27577745zm.802065 1.78653705c-.0087555.0346665-.0225949.0558084-.0419418.0716648-.0214654.0152346-.0562051.0206755-.1080323.0206755h-.1506803l.0088968-.2824619h-.626728l-.0254193 1.380908c-.0009886.0996467.007767.1573206.0739985.2034908.0662315.0576738.2702923.0649802.5449624.0649802h.392729l.1417834-.5168883-.3418902.0206755-.1136809.0073064c-.0155341-.0073064-.030362-.013991-.0468846-.0321792-.0144043-.015701-.0386939-.0060627-.0347398-.1057095l.0026831-.3539713.3585541-.0163228c.1936107 0 .2763648-.0693331.346974-.1354015.0673612-.0632702.0893913-.1360232.1148107-.2344264l.0601592-.3133975h-.4927118z"
                                  fill="#fefefe"
                                />
                              </g>
                            </svg>
                          </span>
                          : null}
                      </div>
                    </div>

                  </Form.Group>
                  <div className="card_extra_details d-flex mb-3">
                    <div className=" w-25 mr-2">
                      <Form.Label className="mb-2">Expires:</Form.Label>
                      <CardExpiryElement />
                    </div>
                    <div className="csv_card_number w-25 ml-2">
                      <Form.Label className="mb-2">CVC:</Form.Label>
                      <CardCvcElement />
                    </div>
                  </div>
                  {error && <ErrorMessage>{error.message}</ErrorMessage>}
                  {/* <button type="submit" disabled={!stripe || prgressIn || !cardComplete || !nTimeZoneID || !selectedDays} className="btn-button"> */}
                  <button variant="primary" type="submit" disabled={prgressIn || !cardComplete} className="btn-button" style={{ width: "100%" }}>
                    {
                      isLoading
                        ? <CircularProgress />
                        : <span>Process Payment</span>
                    }
                  </button>
                </Form>
              </Container>
            </div>
          </Elements>
        </Modal.Body>
      </Modal>

      <Modal
        show={showCheckInDatesModal}
        className={"checkin-dates-modal"}
        onHide={() => {
          setSelectedDate(null);
          setShowCheckInDatesModal(false);
        }}
        size="lg"
        centered
      >
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#0069d9", color: "white" }}
        >
          <Modal.Title>Check In Dates for the Year</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          {/* {priceplans.filter(e => e.price == (servicePlan?.serviceplanfreq == "M" ? servicePlan?.monthlyrate : servicePlan?.yearlyrate)).map((e, idx) => {
            return (
              <div className={"text-center mb-4"}>
                <h5 className="mb-2"><b>Your current subscription is:</b></h5>
                <h5 className="mb-2"><b>{e.CheckIn} - Service Plan</b></h5>
                <h5 className="mb-2"><b>{e.billed}</b></h5>
              </div>
            )
          })} */}
          {currentUser?.ServicePlan &&
            <div className={"text-center mb-4"}>
              <h5 className="mb-2"><b>Your current subscription is: {currentUser?.ServicePlan}</b></h5>
            </div>
          }
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex gap-2">
              <Button
                variant="danger"
                size="sm"
                className="me-2"
                disabled={!selectedDate}
                onClick={() => {
                  setShowDeleteModal(true);
                }}
              >
                Delete
              </Button>

              <Button
                variant="primary"
                size="sm"
                onClick={() => {
                  if (selectedDate) {
                    setFormData({
                      id: selectedDate.id,
                      date: selectedDate.date
                        ? dayjs(selectedDate.date).format('YYYY-MM-DD')
                        : '',
                      message: selectedDate.msg,
                    });
                  } else {
                    setFormData({
                      id: 0,
                      date: '',
                      message: ''
                    });
                  }

                  setShowAddEditModal(true);
                  setErrormessage("");
                  setSuccessmessage("");
                }}
              >
                Add / Edit
              </Button>
            </div>
            <Button
              variant="primary"
              size="sm"
              className="me-2"
              onClick={() => handleShowPlanModal(true)}
            >
              {servicePlan?.id === 45 ? "Upgrade" : "Regenerate Check In Dates"}
            </Button>
          </div>
          {/*<div className="checkin-dates-data-container">*/}
          {/*  <h6 className="mb-2">Checkin Dates for Year :</h6>*/}
          {/*  {checkInDates.map((date) => {*/}
          {/*    return (*/}
          {/*      <>*/}
          {/*        <div className="date-label">{date}</div>*/}
          {/*        <hr className={"m-0"} />*/}
          {/*      </>*/}
          {/*    );*/}
          {/*  })}*/}
          {/*</div>*/}
          <div className="checkin-dates-data-container">
            {/* Header */}
            <div className="d-flex fw-bold border-bottom pb-2 mb-2">
              <div style={{ width: "60px" }}>Select</div>
              <div style={{ width: "120px" }}>Date</div>
              <div className="flex-grow-1">Message to be Sent</div>
            </div>

            {/* Rows */}
            {checkInDates.map((item) => {
              const msgHtml = item.msg || "";

              return (
                <div
                  key={item.id}
                  className="d-flex align-items-center border-bottom py-2 row-hover flex-nowrap"
                >
                  {/* Checkbox */}
                  <div style={{ width: "60px" }}>
                    <input
                      type="checkbox"
                      checked={selectedDate?.id === item.id}
                      onChange={() =>
                        setSelectedDate((prev) => (prev?.id === item.id ? null : item))
                      }
                    />
                  </div>

                  {/* Date */}
                  <div
                    style={{
                      width: "120px",
                      cursor: "pointer",
                      flexShrink: 0,
                    }}
                  >
                    {item.date}
                  </div>

                  {/* Message (render HTML + tooltip) */}
                  <div
                    className="message-preview-wrapper flex-grow-1"
                  >
                    <div
                      className="message-preview"
                      dangerouslySetInnerHTML={{ __html: msgHtml }}
                    />

                    {/* HTML Tooltip */}
                    <div
                      className="message-tooltip"
                      dangerouslySetInnerHTML={{ __html: msgHtml }}
                    />
                  </div>
                </div>
              );
            })}
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btngenie"
            onClick={() => {
              setSelectedDate(null);
              setShowCheckInDatesModal(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showOldCheckInDatesModal}
        className={"checkin-dates-modal"}
        onHide={() => {
          setShowOldCheckInDatesModal(false);
        }}
      >
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#0069d9", color: "white" }}
        >
          <Modal.Title>Old Checkin Dates</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          {priceplans.filter(e => e.price == (servicePlan?.serviceplanfreq == "M" ? servicePlan?.monthlyrate : servicePlan?.yearlyrate)).map((e, idx) => {
            return (
              <div className={"text-center mb-4"}>
                <h5 className="mb-2"><b>Your current subscription is:</b></h5>
                <h5 className="mb-2"><b>{e.CheckIn} - Service Plan</b></h5>
                <h5 className="mb-2"><b>{e.billed}</b></h5>
              </div>
            )
          })}

          <div className="checkin-dates-data-container">
            {/* Header */}
            <div className="d-flex fw-bold border-bottom pb-2 mb-2">
              <div style={{ width: "120px" }}>Date</div>
              <div className="flex-grow-1">Message</div>
            </div>

            {/* Rows */}
            {oldCheckInDates.map((item) => (
              <div
                key={item.id}   // ✅ use id, not date
                className="d-flex align-items-center border-bottom py-2 position-relative"
                onMouseEnter={() => setHoveredDate(item.id)}
                onMouseLeave={() => setHoveredDate(null)}
              >
                {/* Date */}
                <div style={{ width: "120px" }}>{item.date}</div>

                {/* Message column */}
                <div className="flex-grow-1">
                  {hoveredDate === item.id && (
                    <div
                      className="hover-message"
                      dangerouslySetInnerHTML={{ __html: item.msg }}
                      style={{
                        border: "1px solid #dee2e6",
                        borderRadius: "6px",
                      }}
                    />
                  )}
                </div>

              </div>
            ))}
          </div>


        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btngenie"
            onClick={() => {
              setShowOldCheckInDatesModal(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered size="sm">
        <Modal.Header
          closeButton
          className="bg-primary text-white"
        >
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to delete this date?
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeleteModal}>
            Cancel
          </Button>

          <Button
            variant="danger"
            onClick={() => {
              handleDelete();
              // handleCloseDeleteModal();
            }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showAddEditModal} onHide={() => {
        setShowAddEditModal(false);
        setErrormessage("");
        setSuccessmessage("");
      }}
        onEntered={() => {
          if (!editorRef.current) return;

          const contentState = editorState.getCurrentContent();

          if (!contentState.hasText()) {
            editorRef.current.focusEditor();
            return;
          }

          const lastBlock = contentState.getLastBlock();
          const lastKey = lastBlock.getKey();
          const lastLength = lastBlock.getLength();

          const selection = SelectionState.createEmpty(lastKey).merge({
            anchorOffset: lastLength,
            focusOffset: lastLength,
          });

          const newEditorState = EditorState.forceSelection(
            editorState,
            selection
          );

          setEditorState(newEditorState);

          setTimeout(() => {
            editorRef.current.focusEditor();
          }, 0);
        }}
      >
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>
            {selectedDate ? "Change Message" : "Add New Date"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Date field */}
          <div className="mb-0">
            <label className="form-label" style={{ fontWeight: "bold" }}>Date:</label>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div className="d-flex gap-2 align-items-center position-relative">
                {/* Display field */}
                <input
                  type="text"
                  className="form-control"
                  value={
                    formData.date
                      ? dayjs(formData.date, 'YYYY-MM-DD').format('MM-DD-YYYY')
                      : ''
                  }
                  disabled={!!selectedDate}
                  readOnly
                  onClick={() => !selectedDate && setShowCalendar(!showCalendar)}
                  style={{
                    cursor: selectedDate ? 'default' : 'pointer', width: "115px", display: "inline-block",
                  }}
                  placeholder="MM-DD-YYYY"
                />

                {/* External button */}
                {!selectedDate && (
                  <button
                    type="button"
                    className="btn btn-outline-secondary p-2"
                    onClick={() => setShowCalendar(!showCalendar)}
                    title="Open calendar"
                  >
                    📅
                  </button>
                )}

                {/* Calendar dropdown */}
                {showCalendar && !selectedDate && (
                  <div className="position-absolute top-100 start-0 mt-1 bg-white border rounded shadow-lg"
                    style={{ zIndex: 10000 }}>
                    <DateCalendar
                      value={formData.date ? dayjs(formData.date, 'YYYY-MM-DD') : null}
                      minDate={dayjs()}
                      onChange={(newValue) => {
                        setFormData({
                          ...formData,
                          date: newValue ? newValue.format('YYYY-MM-DD') : ''
                        });
                        setShowCalendar(false);
                      }}
                    />
                  </div>
                )}
              </div>
            </LocalizationProvider>


          </div>

          {/* Message */}
          <div className="mb-0" style={{ height: "200px" }}>
            <label className="form-label" style={{ fontWeight: "bold" }}>Message to be sent</label>

            <div className="border rounded d-flex flex-column" style={{ height: "90%" }}>
              <Editor
                ref={editorRef}
                editorState={editorState}
                wrapperClassName="rdw-wrapper"
                toolbarClassName="rdw-toolbar"
                editorClassName="rdw-editor"
                handleBeforeInput={handleBeforeInput}
                onEditorStateChange={(state) => {
                  const charCount = getCharCount(state);

                  if (charCount > MAX_CHARS) return;
                  setEditorState(state);

                  const html = draftToHtml(
                    convertToRaw(state.getCurrentContent())
                  );

                  setFormData(prev => ({
                    ...prev,
                    message: html
                  }));
                }}

                toolbar={{
                  options: ["inline", "blockType", "list", "link", "emoji"],
                  inline: {
                    options: ["bold", "italic", "underline"]
                  },
                  list: {
                    options: ["unordered", "ordered"]
                  },
                  link: {
                    defaultTargetOption: "_blank",
                    showOpenOptionOnHover: false
                  }
                }}
                editorStyle={{
                  maxHeight: "100px",
                  flex: 1,
                  padding: "10px",
                  overflowY: "auto"
                }}
              />
              <div
                className="text-end text-muted px-2 py-1"
                style={{ fontSize: "12px", position: "absolute", top: "275px" }}
              >
                {getCharCount(editorState)} / {MAX_CHARS}
              </div>
            </div>
          </div>
          {errormessage && (
            <Alert variant="danger">
              {errormessage}
            </Alert>
          )}

          {successmessage && (
            <Alert variant="success">
              {successmessage}
            </Alert>
          )}

        </Modal.Body>

        <Modal.Footer className="pt-0">
          <Button
            variant="primary"
            onClick={() => {
              handleAddOrEditDate();
              // setShowAddEditModal(false);
            }}
          >
            OK
          </Button>

          <Button
            variant="secondary"
            onClick={() => {
              setShowAddEditModal(false);
              setErrormessage("");
              setSuccessmessage("");
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal show={serviceplandata} onHide={seriveModelclose}>
        <Modal.Header
          closeButton
          className={"modelHeader"}
          onClick={seriveModelclose}
        >
          <Modal.Title>Daily Service Plan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={"ml-3 dataMain"}>
            Time Slots indicates what time you commit to checking in each day of
            the week.
            <br />
            <br />
            Time Slots applies only to people who have chosen the Daily or 3
            Days per week Service Plan.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btngenie" onClick={seriveModelclose}>
            Okay
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={massagemodel} onHide={handlecloseMassageModel}>
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#0069d9", color: "white" }}
        >
          <Modal.Title>Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            Thank you. Your email was sent to Keys To My Wishes Support Staff
            and we will get back to you soon!
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btngenie" onClick={handlecloseMassageModel}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={ReportIssues} onHide={handleReportIssuse} size={"lg"}>
        <Modal.Header
          closeButton
          style={{ borderBottom: "none" }}
          className={"modelcontact"}
        ></Modal.Header>
        <Modal.Body>
          <div className="contact-form-section1 contact-form-section-1">
            <div className="contact-form-section-wrapper1">
              <div className="container">
                <div className="row gx-5 contact-form-section-row justify-content-center">
                  <div className="report_model">
                    <div className="contact-form drop-shadow-2">
                      <div className="contact-form-wrapper">
                        <div className="section-heading section-heading-2 center">
                          <div className="sub-heading c-blue upper ls-1">
                            <i className="las la-envelope" />
                            <h5>Report Issues</h5>
                          </div>
                          <div className="main-heading c-dark"></div>
                        </div>

                        <form
                          autoComplete={"off"}
                          onSubmit={handlesubmitReport}
                        >
                          <div className="form-floating">
                            <TextField
                              id="form-floating-text"
                              label="Full name"
                              fullWidth
                              disabled={true}
                              value={fname + " " + lname}
                            />
                          </div>
                          <div className="form-floating">
                            <TextField
                              id="form-floating-text"
                              type={"email"}
                              label="Email address"
                              fullWidth
                              required
                              value={email1}
                              disabled={true}
                            />
                          </div>
                          <div className={"pt-2"}>
                            <Form.Label style={{ color: "black" }}>
                              Message *
                            </Form.Label>
                            <Form.Control
                              style={{ color: "black" }}
                              as="textarea"
                              className="textArea"
                              rows={4}
                              required
                              value={ReportMessage}
                              onChange={(e) => setReportMessage(e.target.value)}
                            />
                          </div>
                          <button type="submit" className="button button-3">
                            <span className="button-inner">
                              <span className="button-content">
                                <span className="text">
                                  <span>Submit</span>
                                </span>
                              </span>
                            </span>
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={openPrintPagesModel} onHide={handlePrintPages} size={"md"}>
        <Modal.Header
          closeButton
          style={{ borderBottom: "none" }}
          className={"modelcontact"}
        >
          <Modal.Title>Print Pages</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <Row className="mx-0">
              <h6 className="d-block w-100">Newly Added page(s)</h6>
              {[{ file: "my_story", pdf: my_story }].map((pdf) => (
                <label>
                  <input
                    type="checkbox"
                    value={pdf.file}
                    checked={selectedValues === pdf.file}
                    onChange={handleCheckboxChange}
                  /> My Story
                </label>
              ))}
            </Row>

            <div className="d-flex gap-2 flex-wrap mb-3">
              <Button onClick={handleDownload}> Download Personal Affairs Organizer Pages</Button>
            </div>

            <Row>
              <Col md={6}>
                {firstHalf.slice(0, 16).map((pdf, index) => (
                  !pdf.hidden && (
                    <Col md={12} className="p-0">
                      <label>
                        <input
                          type="checkbox"
                          value={pdf.file}
                          checked={selectedValues === pdf.file}
                          onChange={handleCheckboxChange}
                        /> {pdf.title}
                      </label>
                    </Col>
                  )
                ))}
              </Col>

              <Col md={6}>
                {secondHalf.slice(-16).map((pdf, index) => (
                  !pdf.hidden && (
                    <Col md={12} className="p-0">
                      <label key={index}>
                        <input
                          type="checkbox"
                          value={pdf.file}
                          checked={selectedValues === pdf.file}
                          onChange={handleCheckboxChange}
                        /> {pdf.title}
                      </label>
                    </Col>
                  )
                ))}
              </Col>
            </Row>
          </form>
        </Modal.Body>
      </Modal>


      {/*=======otp radio button ======*/}

      <Modal
        show={sendOTP}
        onHide={() => {
          if (Cookie.get("isFirstTime") === "1") {
            logoutHandler()
          } else {
            handleCloseOTPVerificationModal();
          }
        }}
      >
        <Modal.Header
          closeButton
          className={"modelHeader"}
        >
          <Modal.Title>Send OTP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={"ml-3 dataMain"}>
            <RadioGroup
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
            >
              <div className="d-flex align-items-center">
                <FormControlLabel
                  value={"email"}
                  label="Send Email"
                  control={<Radio color="primary" />}
                />
                <span>{email1}</span>
              </div>
              <div className="d-flex align-items-center">
                {number ? (
                  <FormControlLabel
                    value={"phone"}
                    label="Send Message"
                    control={<Radio color="primary" />}
                  />
                ) : (
                  <FormControlLabel
                    disabled
                    label="Send Message"
                    control={<Radio color="primary" />}
                  />
                )}
                <span>{number}</span>
              </div>
            </RadioGroup>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {!Boolean(isTwoFactorChecked) && (
            <Button
              className="btngenie"
              onClick={handleCloseOTPVerificationModal}
            >
              Close
            </Button>
          )}
          <Button
            className="btngenie"
            style={{ height: "40px", width: "60px" }}
            onClick={handleSubmitOTP}
          >
            {isSending ? <CircularProgress /> : <span>Send</span>}
          </Button>
        </Modal.Footer>
      </Modal>

      {/*two factor */}
      <Modal
        show={otpModalOpen}
        onHide={() => {
          if (Cookie.get("isFirstTime") === "1") {
            logoutHandler();
          } else {
            handleOtpModelclose();
          }
        }}
        backdrop="static"
        size="lg"
        className="HowToUse-Modal-Container mainmodelheder"
      >
        <Modal.Header closeButton style={{ border: "none" }} />
        <Modal.Body>
          <div>
            <div className="card">
              {otpisValid && <Alert variant={"danger"}>{validOTP}</Alert>}
              <h5 className=" text-center mt-4">OTP Verification</h5>
              <h6 className={"text-center mt-2"}>
                {sendTwoFactorOTP
                  ? "You must enter the code in order to Turn off Two Factor Authentication"
                  : "You must enter the code in order to gain access to your Maintenance module"}
              </h6>
              {otpModalOpen && (
                <div className="d-flex justify-content-center mt-4 otpInput optbox">
                  <OtpInput
                    shouldAutoFocus={true}
                    value={otp}
                    onChange={handleChangeotp}
                    numInputs={6}
                    isInputNum={true}
                    separator={<span>&nbsp;</span>}
                    className="otpInputBox"
                  />
                </div>
              )}

              <div className="mt-4 text-center mb-4">
                <button
                  className="btn btn-primary px-4 validate exit_button"
                  onClick={handleValidatetwofactor}
                >
                  {" "}
                  Submit
                </button>
              </div>
              <div className={"text-center mb-2"}>
                <p className={"resentOtpBtn"} onClick={handleSubmitOTP}>
                  Resend OTP
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showInvalidCheckModal}
        onHide={() => setShowInvalidCheckModal(false)}
        className={"invalid-check-modal"}
        centered
      >
        <Modal.Header
          closeButton
          className="justify-content-center"
          style={{ backgroundColor: "#0069d9", color: "white" }}
        >
          <Modal.Title>Checking In</Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="text-center"
          style={{ fontSize: "15px" }}
        >
          <Row className="justify-content-center">
            <span>
              Sorry {localStorage.getItem("name")}, your next scheduled check in date is:{" "}
              <br />
              <strong>
                {nextcheckindate
                  ? moment(nextcheckindate).format("MMMM DD, YYYY")
                  : ""}
              </strong>
            </span>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btngenie"
            onClick={() => setShowInvalidCheckModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showAlreadyCheckedInModal}
        onHide={() => setShowAlreadyCheckedInModal(false)}
        className={"invalid-check-modal"}
      >
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#0069d9", color: "white" }}
        >
          <Modal.Title>Sorry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {localStorage.getItem("name")}, You have already checked in today.
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btngenie"
            onClick={() => setShowAlreadyCheckedInModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showAcceptConfirmationModal} onHide={() => setShowAcceptConfirmationModal(false)}>
        <Modal.Header closeButton className={"modelHeader"}>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to Accept/Decline?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowAcceptConfirmationModal(false)}>
            Decline
          </Button>
          <Button
            style={{ backgroundColor: "#0069d9" }}
            onClick={() => { }}
          >
            Accept
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={shareWithGuest} onHide={handleShareWithGuestModel} className={'guest_list_model'}>
        <Modal.Header closeButton>
          <Modal.Title>Share With Accept/Decline</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={'guest-list'}>
            <span className={'guest_name'}>Rand Friarson</span>
            <div>
              <Button variant="danger mr-1">Decline</Button>
              <Button style={{ backgroundColor: "#0069d9" }}>Accept</Button>
            </div>
          </div>
          <hr className={'line'} />
          <div className={'guest-list'}>
            <span className={'guest_name'}>Rand Friarson</span>
            <div>
              <Button variant="danger mr-1">Decline</Button>
              <Button style={{ backgroundColor: "#0069d9" }}>Accept</Button>
            </div>
          </div>
          <hr className={'line'} />
          <div className={'guest-list'}>
            <span className={'guest_name'}>Rand Friarson</span>
            <div>
              <Button variant="danger mr-1">Decline</Button>
              <Button style={{ backgroundColor: "#0069d9" }}>Accept</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <div className={"mainDashboard"}>
        <Modal show={false} onHide={handleCheckAccount}>
          <Modal.Header closeButton className={"modelHeader"}>
            <Modal.Title>Account Activation Required</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Your trial period has ended and in order to continue you are
            required to choose a Subscription Plan.
            <br />
            Go to the Wishes mode and choose Service Plan in order to choose
            your plan.
            <br />
            <br />
            Otherwise you may Remove your account by sending us an email at:
            support@keystomywishes.com requesting that we remove your account
            from our system.
            <br />
            <br />
            Thank You
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btngenie"
              onClick={handleCheckAccount}
              style={{ backgroundColor: "#0069d9", color: "white" }}
            >
              {" "}
              Okay{" "}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={HomeGenieModel}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          centered
          size="lg"
          className="HowToUse-Modal-Container"
        >
          <Modal.Header closeButton className={"modelHeader"} >
            <div
              className="dashboard-modal-title"
              dangerouslySetInnerHTML={{ __html: LegendDataHome.theheader }}
            />
          </Modal.Header>
          <Modal.Body>
            <div dangerouslySetInnerHTML={{ __html: LegendDataHome.thetext }} />
          </Modal.Body>
        </Modal>

        <Modal show={planNotSelected} onHide={handleClosePlan}>
          <Modal.Header closeButton className={"modelHeader"}>
            <Modal.Title>Please Select Your Plan!</Modal.Title>
          </Modal.Header>
          <Modal.Body>Please Select Your Plan!</Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              style={{ backgroundColor: "#0069d9" }}
              onClick={handleClosePlan}
            >
              Okay
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showLegend} onHide={handleCloseLegend}>
          <Modal.Header
            closeButton
            className={"modelHeader"}
            onClick={handleCloseLegend}
          >
            <Modal.Title>{LegendData.theheader}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className={"ml-3 dataMain"}
              dangerouslySetInnerHTML={{ __html: LegendData.thetext }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button className="btngenie" onClick={handleCloseLegend}>
              Okay
            </Button>
          </Modal.Footer>
        </Modal>
        <section className="dashbord-section">
          <Header title="HOME" />
          <Row className="mx-auto  mobile-button back-logout-btn">
            {localStorage.getItem("isAuthenticatedOTP") === "1" && (
              <Col lg={6} md={6} sm={6} xs={6} className="text-start">
                <Col lg={1} md={12} className="menu-bars">
                  <div className="mt-2 manubutton" onClick={() => OpenSidebar()}>
                    <div className="bar1" />
                    <div className="bar2" />
                    <div className="bar3" />
                    <div className="bar4" />
                    <div className="bar5" />
                    <div className="Menu-Text">Menu</div>
                  </div>
                </Col>
              </Col>
            )}
            <Col
              lg={6}
              md={6}
              sm={6}
              xs={6}
              className="text-right main_header_right"
              style={{ paddingTop: "10px" }}
            >
              <Logout />
            </Col>
            <div className="more_options w-100 px-3">
              <Paper className={classes.root}>
                {localStorage.getItem("isAuthenticatedOTP") === "1" && (
                  <Tabs
                    value={getDefaultAlign}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                    onChange={handleChangeTab}
                  >
                    <Tab label="KEEP IN TOUCH" />
                    {/*<Tab label="Wishes" />*/}
                    {/*<Tab*/}
                    {/*    style={{overflow:"visible"}}*/}
                    {/*    label={*/}
                    {/*      <div>*/}
                    {/*        Shared*/}
                    {/*        /!*{(*!/*/}
                    {/*        /!* (isNewUser == 0) &&*!/*/}
                    {/*        /!* (sharedReleaseCount && sharedReleaseCount["hasAccessRequestFlag"] === 1) &&*!/*/}
                    {/*        /!* (Cookie.get("isPendingApproval") === "1")*!/*/}
                    {/*        /!*) && (*!/*/}
                    {/*        /!*    <span className="blink_me">*** Pending Request Approval</span>*!/*/}
                    {/*        /!*)}*!/*/}
                    {/*      </div>*/}
                    {/*    }*/}
                    {/*/>*/}
                  </Tabs>
                )}
              </Paper>
            </div>
          </Row>

          {ShowAccordian && (
            <div className={"position-absolute GenieModelMainDashboard"}>
              <Accordion
                className={"mainAccordian-mainDash"}
                expanded={expanded === "panel1"}
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon onClick={() => getLegendDataHome("12")} />
                  }
                  aria-controls="panel1a-content"
                  id="mainAccordianSummery-mainDash"
                  style={{ height: "48px" }}
                >
                  <span className={"w-100"}>
                    <Typography className={classes.heading}>
                      How to Use the System
                      <span
                        className={"float-right"}
                        style={styles.textDecoration}
                      >
                        Tips
                      </span>
                    </Typography>
                  </span>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography style={{ width: "100%" }}>
                    <div className="How-to-use-Container">
                      <p onClick={() => getLegendDataHome("13")}>
                        <img
                          src={key_gold}
                          height="18px"
                          alt={"Key Gold"}
                          className="key-gold-img"
                        />
                        <span className="How-to-use-title">Check In Only</span>
                      </p>
                      <p onClick={() => getLegendDataHome("14")}>
                        <img
                          src={key_gold}
                          height="18px"
                          alt={"Key Gold"}
                          className="key-gold-img"
                        />
                        <span className="How-to-use-title">
                          Check In & Digital Vault
                        </span>
                      </p>
                      <p onClick={() => getLegendDataHome("15")}>
                        <img
                          src={key_gold}
                          height="18px"
                          alt={"Key Gold"}
                          className="key-gold-img"
                        />
                        <span className="How-to-use-title">
                          Digital Vault Only
                        </span>
                      </p>
                      <p onClick={() => getLegendDataHome("16")}>
                        <img
                          src={key_gold}
                          height="18px"
                          alt={"Key Gold"}
                          className="key-gold-img"
                        />
                        <span className="How-to-use-title">
                          Wishes Shared With Me
                        </span>
                      </p>
                      <p onClick={() => getLegendDataHome("17")}>
                        <img
                          src={key_gold}
                          height="18px"
                          alt={"Key Gold"}
                          className="key-gold-img"
                        />
                        <span className="How-to-use-title">
                          Retrieve Wishes Released To Me
                        </span>
                      </p>
                      <p onClick={() => getLegendDataHome("18")}>
                        <img
                          src={key_gold}
                          height="18px"
                          alt={"Key Gold"}
                          className="key-gold-img"
                        />
                        <span className="How-to-use-title">
                          Break The Glass
                        </span>
                      </p>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          )}
          {currentUser?.nHasCheckInDates === 0 &&
            <Row className="justify-content-center">
              <Col xs={12} sm={8} md={6} lg={4} className="d-flex justify-content-center">
                <Button
                  onClick={() => setShowPlanModal(true)}
                  className="viewCheckInBtn w-50 text-nowrap"
                >
                  Choose CheckIn Plan
                </Button>
              </Col>
            </Row>
          }

          {!!nShowads && (
            <div className="imageContainer justify-content-center text-center">
              <img src={BannderAd} alt="advertisment" />
            </div>
          )}
          {localStorage.getItem("isAuthenticatedOTP") === "1" && (
            <Row className={`mx-auto text-center dashboard-card align-items-center justify-content-center`}>
              <Col
                xl={12}
                className="d-flex justify-content-center mx-auto flex-wrap"
              >
                {getDefaultAlign === 0 ? (
                  <Col xl={5} lg={4} sm={7}>
                    <div className="datacenter datacenter-container">
                      {currentUser?.checkinOnOff === 1 &&
                        <div>
                          <span className="mb-3 d-block maindash-custom-font">
                            Currently CheckIn is Disabled!
                          </span>
                        </div>
                      }
                      <div>
                        <span className="mb-3 d-block maindash-custom-font">
                          {localStorage.getItem("name")}, you last checked in:
                          {checkInTime
                            ? moment(checkInTime).format(" MMMM DD, YYYY  h:mm A")
                            : ""}
                        </span>

                        <span className="maindash-custom-font custom-border">
                          Your next scheduled check in date is:{" "}
                          {nextcheckindate
                            ? moment(nextcheckindate).format(" MMMM DD, YYYY")
                            : ""}
                        </span>
                      </div>
                      <div className="checkBotton">
                        {Boolean(!isNewUser || servicePlanRequired) && (
                          <Row className="justify-content-center mb-5">
                            <Button
                              onClick={() => handleShowPlanModal(true)}
                              className="viewCheckInBtn"
                            >
                              Purchase Check In Plan
                            </Button>
                          </Row>
                        )}


                        <Row className="checkinbtn mb-5">
                          <img
                            src={Checkinbutton}
                            onClick={HandleCheckIn}
                            style={{ cursor: "pointer" }}
                            height={"190px"}
                          />
                        </Row>
                        {/*<Row className="justify-content-center mb-3">*/}
                        {/*  <Col xs={12} sm={8} md={6} lg={4}>*/}
                        {/*    <Button*/}
                        {/*        onClick={handleShowOldCheckInDatesModal}*/}
                        {/*        className="viewCheckInBtn w-100 text-nowrap"*/}
                        {/*    >*/}
                        {/*      View Old Dates*/}
                        {/*    </Button>*/}
                        {/*  </Col>*/}
                        {/*</Row>*/}

                        <Row className="justify-content-center">
                          <Col xs={12} sm={8} md={6} lg={4}>
                            <Button
                              onClick={handleShowCheckInDatesModal}
                              className="viewCheckInBtn w-100 text-nowrap"
                            >
                              View Checkin Dates
                            </Button>
                          </Col>
                        </Row>

                        {getDefaultAlign === 0 && (
                          <div className={"pt-5"}>
                            <h5
                              className={"font-weight-bold"}
                              style={{
                                color: "purple",
                                fontFamily: "Monotype Corsiva",
                                fontSize: "22px",
                              }}
                            >
                              Quote of the Day
                            </h5>
                            <div className={"quoteContainer"}>
                              <p
                                className={"quoteOftheDay"}
                                dangerouslySetInnerHTML={{
                                  __html: quoteoftheday,
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                ) : (
                  getDefaultAlign === 0 &&
                  localStorage.getItem("isAuthenticatedOTP") === "1" && (
                    <>
                      <div className="dashboard-button">
                        <div className="d-flex datacenter">
                          <Button
                            className="Handlemycontact"
                            onClick={() => handleRoutes("/contacts")}
                          >
                            <span className="Image_home">
                              <img src={ic_users} />
                            </span>
                            <span className="home_btn">My Contacts</span>
                          </Button>
                          <Button
                            className="Handlemycontact"
                            onClick={profileLink}
                          >
                            <span className="Image_home">
                              <img src={profile_icon} />
                            </span>
                            <span className="home_btn">My Profile</span>
                          </Button>
                        </div>
                        <div className="d-flex datacenter">
                          <Button
                            className="Handlemycontact"
                            onClick={() => handleRoutes("/newDashboard")}
                          >
                            <span className="Image_home_wishes">
                                <img src={Wishes_icon} className={"wishes_icon"} />
                              </span>
                              <span className="home_btn">My Wishes</span>
                            </Button>
                            <Button
                              className={(!isLoadingPlan && !servicePlan) ? "service_plan" : "Handlemycontact"}
                              onClick={() => history.push(ServiceLink())}
                            >
                              <span className="Image_home">
                                <img src={Serive_icon} />
                              </span>
                              <span className="home_btn">{(!isLoadingPlan && !servicePlan) ? "Purchase Book/Service" : "Purchase Book"}</span>
                            </Button>
                          </div>
                          <div className="d-flex datacenter">
                            {showViewMemoryBtn && (
                              <Button
                                className="Handlemycontact"
                                onClick={() => handleRoutes("/my-albums")}
                              >
                                <span className="Image_home">
                                  <img src={memory_icon} />
                                </span>
                                <span>My Memories</span>
                              </Button>
                            )}

                            <Button
                              className="Handlemycontact"
                              onClick={ChangePasswordLink}
                            >
                              <span className="Image_home">
                                <img src={Password_icon} />
                              </span>
                              <span>Change Password</span>
                            </Button>
                          </div>

                      </div>
                    </>
                  )
                )}
              </Col>
              {getDefaultAlign === 1 &&
                localStorage.getItem("isAuthenticatedOTP") === "1" && (
                  <>
                    <Row className={"mutplefamily-container px-3 m-0 mb-2"}>
                      <div
                        className={"d-flex justify-content-center flex-column"}
                      >
                        <div className="multifamily">
                          <span className="text_reb"> As a Guest there is no Cost to use this module to view Wishes from your loved ones!</span>
                          <h5 className="mt-2">WISHES SHARED/RELEASED TO YOU</h5>
                          <span className={"pb-2"}>
                            The following two buttons relate to Wishes that are
                          Shared or Released to you.<br /> The information comes from
                          your loved ones who have chose to Share or Release a
                          Wish to You.
                        </span>
                      </div>
                      <div className="mt-5 d-flex justify-content-center">

                        {sharedReleaseCount && Boolean(sharedReleaseCount.showAccessButton) && (
                          <button
                            className={"btn mr-2 text-nowrap btn request-access-btn btn-success"}
                            style={{ width: "fit-content" }}
                            onClick={() => toggleApprovalModal()}
                          >Manage Share Access
                          </button>
                        )}
                      </div>
                      <div className="d-flex released_content justify-content-between"
                        style={{
                          margin: "20px 0",
                        }}
                      >
                        <div className="datacenter multifamily">
                          <div className="mycontactBotton">
                            <button
                              className={"btn mr-2 text-nowrap btn request-access-btn btn-success mb-4"}
                              style={{ width: "fit-content" }}
                              onClick={() => {
                                setAccessType("Share")
                                setAccessRequest(true)
                              }}
                            >Request Share Access
                            </button>
                            <Row className="mycontactbtn m-0">
                              <p className="wishes_description">The Wishes Shared With You button will display Wishes from users of the system who have elected to Share their important information with you.</p>
                              <span>{sharedReleaseCount ? wish.text(sharedReleaseCount["SharedWithMe"]) : ""}</span>
                              <Link to={"/Wishes-Shared-with-me"}>
                                <Button className="Handlemycontact">
                                  <img
                                    src={genie_img}
                                    className="Image_home"
                                  />
                                  <span>Wishes <span className={'underline'}>Shared</span> With You</span>
                                </Button>
                              </Link>
                            </Row>
                          </div>
                        </div>
                        <div className="datacenter multifamily">
                          <div className="mycontactBotton">
                            <button
                              className={"btn mr-2 text-nowrap btn request-access-btn btn-success mb-4"}
                                style={{ width: "fit-content" }}
                                onClick={() => {
                                  setAccessType("Release")
                                  setAccessRequest(true)
                                }}
                              >Request Release Access
                              </button>
                              <Row className="mycontactbtn d-flex align-items-center m-0">
                                <p className="wishes_description">The Wishes Released to You button will only display Wishes if the user has become Incapacitated or has passed away. These Wishes would only be Released to you specifically by the user.</p>
                                <span>{sharedReleaseCount ? wish.text(sharedReleaseCount["ReleaseToMe"]) : ""}</span>
                                <Link to={"/Wishes-Released-to-me"}>
                                  <Button className="Handlemycontact">
                                    <img
                                      src={genie_img}
                                      alt="genie_img"
                                      className="Image_home"
                                    />
                                    <span>Wishes <span className={'underline'}>Released</span> To You</span>
                                  </Button>
                                </Link>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Row>
                  </>
                )}

              <div className="start_btn">
                {letsgetstarted === 1 && (
                  <Draggable>
                    <div className="datacenter w-100">
                      {!!start && letsgetstarted ? (
                        <div className="w-100" style={{ cursor: "pointer" }}>
                          {!!getstartData ? (
                            <div className={"getstard"}>
                              <div className="lets_start">
                                <div className="lest_model_title">
                                  <p
                                    style={{ paddingRight: "160px" }}
                                    dangerouslySetInnerHTML={{
                                      __html: getstartData.theheader,
                                    }}
                                  />
                                </div>
                                <div className="pr-2" onClick={closeStart}>
                                  <img src={Close} height={20} width={20} />
                                </div>
                              </div>
                              <p
                                className="lest_model_body"
                                dangerouslySetInnerHTML={{
                                  __html: getstartData.thetext,
                                }}
                              />
                            </div>
                          ) : (
                            <p className={"getstard no_stard"}>
                              {" "}
                              Data not found{" "}
                            </p>
                          )}
                        </div>
                      ) : null}
                    </div>
                  </Draggable>
                )}
              </div>
            </Row>
          )}
          <div
            className={modalOpen ? "overlay active" : "overlay"}
            onClick={() => closeModal()}
          />
          <div className={modalOpen ? "menudrawer active" : "menudrawer"}>
            <div className="modal-title-content">
              <div className=" myprofile-left-section">
                <div className="imges d-flex align-items-center justify-content-center">
                  <img
                    src={
                      profileImage
                        ? profileImage
                        : s3filename
                          ? `https://reactnotes.s3.us-east-2.amazonaws.com/${s3filename}`
                          : defaultProfile
                    }
                    alt={"image"}
                    style={{ backgroundColor: "#fff" }}
                  />
                  <div className="names">
                    <h3 className={"text-capitalize"}>
                      {fname}&nbsp;{lname}
                    </h3>
                  </div>
                </div>
              </div>
              <h6 className={"ml-5 email_address"}>{email1}</h6>
              <div className="close-icon" onClick={() => closeModal()}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="#0069d9">
                  <g fill="none">
                    <path d="M0 0h24v24H0z" opacity="0.05" />
                    <path
                      fill="#0069d9"
                      d="M12.967 12L19.3 5.666a.685.685 0 000-.967.686.686 0 00-.967 0L12 11.033 5.666 4.7a.686.686 0 00-.967 0 .685.685 0 000 .967L11.033 12 4.7 18.334a.685.685 0 000 .967.686.686 0 00.967 0L12 12.967l6.334 6.334a.686.686 0 00.967 0 .685.685 0 000-.967L12.967 12z"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div className="mt-2 ml-2 modal-content-list sidebar_item">
              <ul>
                <li className="mt-4">
                  <Link
                    to="/maindashboard"
                    className="d-flex align-items-center"
                  >
                    <HomeIcon className={"mr-3"} />
                    <span onClick={() => closeModal()}>Home</span>
                  </Link>
                </li>
                <li className="mt-4" style={{ cursor: "pointer", fontWeight: 500 }} onClick={handleopen}>
                  <Link to="/my-profile" className="d-flex align-items-center">
                    <PermIdentityOutlinedIcon className={"mr-3"} />
                    My Profile
                  </Link>
                </li>
                <li className="mt-4" style={{ cursor: "pointer", fontWeight: 500 }} onClick={handleopen}>
                  <Link to="/change-password" className="d-flex align-items-center">
                    <CreateOutlinedIcon className={"mr-3"} />
                    Change Password
                  </Link>
                </li>
                <li className="mt-4" style={{ cursor: "pointer", fontWeight: 500 }} onClick={handleopen}>
                  <Link to="/contacts" className="d-flex align-items-center">
                    <PermContactCalendarOutlinedIcon className={"mr-3"} />
                    Emergency Contact(s)
                  </Link>
                </li>
                <li
                  className="mt-4 d-flex align-items-center"
                  style={{ cursor: "pointer", fontWeight: 500 }}
                  onClick={() => handleShowPlanModal(true)}
                >
                  <DateRangeIcon className="mr-3" />
                  {servicePlan?.id === 45
                    ? "Upgrade"
                    : "Regenerate Check In Dates"}
                </li>
                <li className="mt-4">
                  <Link
                    to="/privacy-policy"
                    className="d-flex align-items-center"
                  >
                    <LockIcon className={"mr-3"} /> Privacy Policy
                  </Link>
                </li>
                <li className="mt-4">
                  <Link
                    to="/terms-of-use"
                    className="d-flex align-items-center"
                  >
                    <AssignmentIcon className={"mr-3"} /> Terms & Conditions
                  </Link>
                </li>
                {/*<li className="mt-4 ">*/}
                {/*  <Link to="/faq" className="d-flex align-items-center">*/}
                {/*    <LiveHelpIcon className={"mr-3"} /> FAQ*/}
                {/*  </Link>*/}
                {/*</li>*/}
                {/*<li className="mt-4">*/}
                {/*  <span*/}
                {/*      className="d-flex reportBtn align-items-center"*/}
                {/*      style={{fontWeight: "500",color:"#ff0f61"}}*/}
                {/*      onClick={handlePrintPages}*/}
                {/*  >*/}
                {/*    <LocalPrintshopIcon className={"mr-3"}/>Download Organizer Pages*/}
                {/*  </span>*/}
                {/*</li>*/}
                {/*<li className="mt-4">*/}
                {/*  <span*/}
                {/*    className="d-flex reportBtn align-items-center"*/}
                {/*    style={{ fontWeight: "500" }}*/}
                {/*    onClick={handleReportIssuse}*/}
                {/*  >*/}
                {/*    <ReportIcon className={"mr-3"} /> Report an Issue*/}
                {/*  </span>*/}
                {/*</li>*/}
                {/*<li className="mt-4 settingFor">*/}
                {/*  <FormControlLabel*/}
                {/*    style={{ fontWeight: "500", marginBottom: "0" }}*/}
                {/*    control={*/}
                {/*      <IOSSwitch sx={{ m: 1 }} onChange={handleSettingFor} />*/}
                {/*    }*/}
                {/*    checked={isTwoFactorChecked === 1}*/}
                {/*  />*/}
                {/*  <span>Two Factor Authentication</span>*/}
                {/*</li>*/}
                {/*<li className="mt-4 settingFor">*/}
                {/*  <FormControlLabel*/}
                {/*    style={{ fontWeight: "500", marginBottom: "0" }}*/}
                {/*    control={*/}
                {/*      <IOSSwitch sx={{ m: 1 }} onChange={handleletgetstart} />*/}
                {/*    }*/}
                {/*    checked={letsgetstarted === 1}*/}
                {/*  />*/}
                {/*  <span>Let's Get Started</span>*/}
                {/*</li>*/}
                { }
                <li
                  className="mt-4"
                  style={{ cursor: "pointer" }}
                  onClick={handleInvitaionModel}
                >
                  <span
                    className="d-flex align-items-center"
                    style={{ fontWeight: "500" }}
                  >
                    <ScreenShareIcon className={"mr-3"} />
                    Send Invitation
                  </span>
                </li>
                <li
                  className="mt-3"
                  style={{ cursor: "pointer" }}
                >
                  <span
                    className="d-flex align-items-center justify-content-between w-100"
                    style={{ fontWeight: "500" }}
                  >
                    <span className="d-flex align-items-center">
                      <NotInterestedIcon className="mr-3" />
                      Suspend Check In
                    </span>

                    <Switch
                      checked={currentUser?.checkinOnOff === 1}
                      color="primary"
                      onChange={hadleSuspendChekedIn}
                    />
                  </span>
                </li>
                {canShowTestText &&
                  < li
                    className="mt-3"
                    style={{ cursor: "pointer" }}
                    onClick={handleInvitaionModel}
                  >
                    <span
                      className="d-flex align-items-center"
                      style={{ fontWeight: "500" }}
                    >
                      <SmsIcon className={"mr-3"} />
                      Test Send Text
                    </span>
                  </li>
                }
                {/*{servicePlanRequired === 0 && (*/}
                {/*    <li className="mt-4" style={{cursor: "pointer", fontWeight: 500}} onClick={() => history.push('/changePlan')}>*/}
                {/*      <PublishedWithChangesIcon className={"mr-3 mt-1"}/> Change Service Plan*/}
                {/*    </li>*/}
                {/*)}*/}

                {servicePlanRequired === 1 && (
                  <li className="mt-3" style={{
                    cursor: 'pointer',
                    fontWeight: 500,
                    opacity: isButtonDisabled ? 0.6 : 1
                  }} onClick={() => !isButtonDisabled && handleShowActiveModel()}>
                    <AddAlertIcon className={"mr-3 mt-1"} /> Activate Service Plan
                  </li>
                )}

                <li className="mt-3" style={{ cursor: "pointer", fontWeight: 500 }} onClick={handleopen}>
                  <ExitToAppIcon className={"mr-3 mt-1"} /> Logout
                </li>
                {/*<li className="mt-4 mb-4" onClick={handleLegendDailog}>*/}
                {/*  <img src={genie_img} className="genie ml-5" />*/}
                {/*</li>*/}
              </ul>
            </div>
          </div>
        </section>
      </div>

      <Modal show={showConfirmation} onHide={handleCloses}>
        <Modal.Header style={{ backgroundColor: "#0069d9", color: "white" }}>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to Logout?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloses}>
            No
          </Button>
          <Button
            style={{ backgroundColor: "#0069d9" }}
            onClick={() => logoutHandler()}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={confirmAccessCode} onHide={() => setConfirmAccess(false)}>
        <Modal.Header style={{ backgroundColor: "#0069d9", color: "white" }}>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Typography gutterBottom>
            {localStorage.getItem("name")}, your Access Request has been sent.
          </Typography>
          <Typography>
            {confirmAccessData}
          </Typography>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ backgroundColor: "#0069d9" }}
            onClick={() => setConfirmAccess(false)}
          >
            Okay
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={accessRequest} onHide={() => {
        setAccessRequest(false)
        setAccessCode('')
      }}>
        <Modal.Header style={{ backgroundColor: "#0069d9", color: "white" }}>
          <Modal.Title>Enter Access Code - {accessType} info</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="text"
            placeholder="Enter Access Code"
            maxLength="20"
            value={AccessCode}
            onChange={(e) => setAccessCode(e.target.value.replaceAll(" ", ""))}
            required
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setAccessRequest(false)
            setAccessCode('')
          }}>
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "#0069d9" }}
            onClick={() => submitAccessCode()}
            disabled={!AccessCode}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={openAsinNumberModal}
        onHide={handlecloseASINModal}
        centered
        size={'md'}
      >
        <Modal.Header style={{ backgroundColor: "#0069d9", color: "white" }}>
          {/*<Modal.Title>title</Modal.Title>*/}
        </Modal.Header>

        <Modal.Body >
          <div>
            <label>Enter the ASIN : </label>
            <input className={"asin-number-input"} value={asinValue} onChange={(e) => setAsinValue(e.target.value)} />
          </div>
        </Modal.Body>
        <form>
          <Modal.Footer >
            <Button onClick={checkAsinNumber} type="submit" className="invite_btn">
              okay
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
      <HandleConfirmation
        isOpen={wrongAsinNumber}
        size="md"
        centered={true}
        handleClose={handleCloseWrongAsinNummberModal}
        onConfirm={handleCloseWrongAsinNummberModal}
        question={
          <div>
            You have entered the incorrect ASIN.<br />
            Look on the back of the book for the ASIN
          </div>
        }
        yesText="Ok"
        noText=""
        title={""}
      />

      {invitaionModel && (
        <SentInvitaionModel
          Fname={fname}
          Lname={lname}
          isOpen={invitaionModel}
          handleCloseNewmodel={handleInvitaionModel}
        />
      )}

      {isOpenSharedModal && (
        <SharedAccessApprovalModal
          isOpen={isOpenSharedModal}
          toggleApprovalModal={toggleApprovalModal}
        />
      )}
      {isOpenPersonalAffairsModal && (
        <HandleConfirmation
          isOpen={isOpenPersonalAffairsModal}
          handleClose={() => setPersonalAffairsModal(false)}
          size="lg"
          centered={false}
          onConfirm={() => {
            if (!isLoadingPlan && !servicePlan) {
              setIsOpenModal(!isOpenModal)
            } else {
              wish.downloadPdfByType("personal_affairs_organizer")
            }
            setPersonalAffairsModal(false)
          }}
          question="Are you sure you want to download the KeysToMyWishes Personal Affairs Organizer?"
          yesText="Yes"
          noText="No"
        />
      )}
      {isOpenModal && (
        <HandleConfirmation
          isOpen={isOpenModal}
          size="lg"
          centered={false}
          handleClose={() => setIsOpenModal(false)}
          onConfirm={() => setIsOpenModal(false)}
          question={selectedValues === "" ? "Please select which page you want to download." : "You will only be allowed to download the book if you have purchased a Service Plan."}
          yesText="Ok"
          noText=""
          title={selectedValues === "" ? "Alert" : "Service Plan is Required"}
        />
      )}
    </div>
  );
};

export default Maindashboard;
